import EnvService from "../../../services/env";

const apiUrl = EnvService.ApiUrl;
const adminUrl = EnvService.AdminApiUrl;
const virtualPrinterUrl = EnvService.VirtualPrinterApiUrl;
const tasksApiUrl = EnvService.TasksApiUrl;
const notesApiUrl = EnvService.NotesApiUrl;
const ncrApiUrl = EnvService.NcrApiUrl;
const bizFileApiUrl = EnvService.BizFileApiUrl;

/** Auth APIs.*/
const authBaseUrl = apiUrl + 'Auth/';
export const authApis = {
    baseUrl: authBaseUrl,
    getConfiguration: authBaseUrl + 'GetAllFrontConfigurations',
    login: authBaseUrl + 'Login',
};

/**
 * Lookup Apis
 */
const lookupBaseUrl = apiUrl + 'Lookup/';
export const lookupApis = {
    baseUrl: lookupBaseUrl,
    makesAndModelsList: lookupBaseUrl + 'AllMakeAndModelsList',
    autoCompletePartLookup: (keywords: string, industryId?: string) => lookupBaseUrl + `AutoCompleteLookupParts?keyword=${encodeURIComponent(keywords)}${industryId ? `&industryId=${encodeURIComponent(industryId)}` : ''}`,
    submitLostSaleReport: lookupBaseUrl + 'SubmitLostSaleReport',
}

/**
 * Company (Customer) Apis
 */
const customersBaseUrl = apiUrl + 'Customers/';
export const customerApis = {
    baseUrl: customersBaseUrl,
    getAllPaymentTerms: customersBaseUrl + `GetAllCustomerPaymentTerms`,
    getAllPriceLevels: customersBaseUrl + `GetAllPriceLevels`,
    update: customersBaseUrl,
    updatePriceLevel: customersBaseUrl + 'UpdatePriceLevel',
    updatePaymentTerms: customersBaseUrl + 'UpdatePaymentTerms',
    getMembersWithAccessLevels: (customerId: number) => customersBaseUrl + `GetAllUsersWithAccessLevelInCustomerForPartner/${encodeURIComponent(customerId)}`,
    getUserAdminByCustomerId: (customerId: number) => customersBaseUrl + `GetUserAdminByCustomerID/${encodeURIComponent(customerId)}`,
}

/**
 * Part Apis
 */
const partBaseUrl = apiUrl + 'Part/';
export const partApis = {
    baseUrl: partBaseUrl,
    getPart: (partNumber: string, searchToken?: string) => partBaseUrl + `?partNo=${encodeURIComponent(partNumber)}${searchToken ? `&searchToken=${encodeURIComponent(searchToken)}` : ''}&isNewAPI=true`,
    getRelatedParts: (partNumber: string) => partBaseUrl + `GetRelatedParts?partNo=${encodeURIComponent(partNumber)}&isNewAPI=true`,
    getFeedbacks: (partNumber: string) => partBaseUrl + `GetAllPartFeedBacks?partNo=${encodeURIComponent(partNumber)}&isNewAPI=true`,
    toggleFeedbackVisibility: (feedbackId: number) => partBaseUrl + `PartFeedbackToggleVisibility/${encodeURIComponent(feedbackId)}`,
    removeFeedback: (feedbackId: number) => partBaseUrl + `PartFeedbackRemove/${encodeURIComponent(feedbackId)}`,
    reportProblem: partBaseUrl + `ReportPartProblem`,
}

/**
 * Part Share Link (link) Apis
 */
const linkBaseUrl = apiUrl + 'PartShareLinks/';
export const linkApis = {
    baseUrl: linkBaseUrl,
    create: linkBaseUrl,
    update: linkBaseUrl,
}

/**
 * Competitors Apis (CleanAF)
 */
const competitorsBaseUrl = apiUrl + 'CleanAF/Competitors';
export const competitorApis = {
    baseUrl: competitorsBaseUrl,
    list: competitorsBaseUrl + '/List',
    add: competitorsBaseUrl + '/Add',
    update: competitorsBaseUrl + '/Update',
    delete: (id: number, replacementId: number) =>
        `${competitorsBaseUrl}/Delete?id=${encodeURIComponent(id)}&replacementId=${encodeURIComponent(replacementId)}`,
    reportPrice: competitorsBaseUrl + '/ReportPrice',
    listPriceReports: competitorsBaseUrl + '/ListPriceReports',
    listMyPriceReports: competitorsBaseUrl + '/ListMyPriceReports',
    checkPriceReport: competitorsBaseUrl + '/CheckPriceReport',
    removePriceReport: (id: number) =>
        `${competitorsBaseUrl}/RemovePriceReport/${encodeURIComponent(id)}`,
}

/**
 * User GIft Cards Apis.
 */
const userGiftCardsBaseUrl = apiUrl + 'UserGiftCards/';
export const userGiftCardApis = {
    baseUrl: userGiftCardsBaseUrl,
    getCustomerGiftCards: (customerId: number, loadAll: true) => userGiftCardsBaseUrl + `GetByCustomer/${encodeURIComponent(customerId)}/${encodeURIComponent(loadAll)}`,
    searchGiftCards: userGiftCardsBaseUrl + `Search`,
    create: userGiftCardsBaseUrl,
    createBulk: userGiftCardsBaseUrl + `CreateCardsBulk`,
    getCategories: userGiftCardsBaseUrl + 'GetCategoriesList',
    getAvailableAmounts: userGiftCardsBaseUrl + 'GetAllValidAmountsForGiftCard',
    createOrUpdateCategory: userGiftCardsBaseUrl + 'CreateOrUpdateCategory',
    removeGiftCard: (cardNumber: string) => userGiftCardsBaseUrl + `${encodeURIComponent(cardNumber)}`,
    removeGiftCardCategory: (categoryId: number) => userGiftCardsBaseUrl + `RemoveCategory/${encodeURIComponent(categoryId)}`,
    refillGiftCard: userGiftCardsBaseUrl + `ReFill`,
    assignToUser: userGiftCardsBaseUrl + `UpdateLockForUser`,
    updateActivationStatus: userGiftCardsBaseUrl + 'UpdateActivationStatus',
    getRefillReasonsForGiftCards: userGiftCardsBaseUrl + 'GetAllRefillReasons',
    updateCategory: userGiftCardsBaseUrl + 'UpdateCategory',
    removeLockForUserFromCard: (cardId: number) => userGiftCardsBaseUrl + `RemoveLockForUserFromCard/${encodeURIComponent(cardId)}`,
    searchHistory: userGiftCardsBaseUrl + `SearchTransaction`,
}

/**
 * User Addresses (addresses) Apis
 */
const userAddressesBaseUrl = apiUrl + 'UserAddresses/';
export const userAddressesApis = {
    baseUrl: userAddressesBaseUrl,
    getAllByCustomer: (customerId: number) => userAddressesBaseUrl + `GetAllByCustomerId/${encodeURIComponent(customerId)}`,
    create: userAddressesBaseUrl + `CreateNewAddress`,
    update: userAddressesBaseUrl + 'UpdateAddress',
    setAsDefault: (addressId: number) => userAddressesBaseUrl + `SetAddressAsDefault/${encodeURIComponent(addressId)}`,
    remove: (addressId: number) => userAddressesBaseUrl + `RemoveAddress/${encodeURIComponent(addressId)}`
}

/**
 * Users Apis
 */
const usersBaseUrl = apiUrl + 'Users/';
export const usersApis = {
    baseUrl: usersBaseUrl,
    getCustomerExtraInfo: (userId: number) => usersBaseUrl + `GetCustomerExtraInfo/${encodeURIComponent(userId)}`,
    loginLogSearch: usersBaseUrl + `UserLoginLogSearch`,
    getMembersAccessLevels: usersBaseUrl + `GetAllAvailableAccessLevelsForUsers`,
    getUserSearchForm: usersBaseUrl + `GetAllUserSearchFormParams`,
    getProfilePageForm: usersBaseUrl + `GetProfilePageRawData`,
    searchAllUsers: usersBaseUrl + `SearchAllUsers`,
    fastSearch: (search: string) => usersBaseUrl + `FastSearch?keyword=${search && search.length ? `${encodeURIComponent(search)}` : ''}`,
    assignCompanyToUser: usersBaseUrl + 'SetCustomerForUserAndActivate',
    removeCompanyFromUser: (userId: number) => usersBaseUrl + `RemoveCustomerFromUser/${encodeURIComponent(userId)}`,
    updateUserAccessLevels: usersBaseUrl + 'UpdateUserAccessLevelsInCustomer',
    update: usersBaseUrl + 'UpdateProfileInfo',
    toggleStatus: (userId: number) => usersBaseUrl + `ToggleUserActivationStatus/${encodeURIComponent(userId)}`,
    create: usersBaseUrl + 'CreateNewUserAndCustomer',
    fastCreateFromSpireCustomer: usersBaseUrl + 'FastCreateUserFromSpireCustomer',
    getBasicInfo: (userId: number) => usersBaseUrl + `GetBasicInfo/${encodeURIComponent(userId)}`,
}

/**
 * Quote Apis
 */
const quotesBaseUrl = apiUrl + 'Quotes/';
export const quotesApis = {
    baseUrl: quotesBaseUrl,
    search: quotesBaseUrl + 'Search',
    searchItems: quotesBaseUrl + 'SearchItems',
    getForCustomer: (customerId: number, quoteId: number) => quotesBaseUrl + `GetFullDetailsByCustomerId/${encodeURIComponent(customerId)}/${encodeURIComponent(quoteId)}`,
    getLastQuoteForCustomer: (customerId: number) => quotesBaseUrl + `GetCustomerLastQuote/${encodeURIComponent(customerId)}`,
    update: quotesBaseUrl + `UpdateItems`,
    updateAddress: quotesBaseUrl + 'UpdateAddress',
    removeTransactionItem: quotesBaseUrl + 'RemoveTransactionItem',
    addCredit: quotesBaseUrl + 'AddCredit',
    addGiftCard: quotesBaseUrl + 'AddGiftCard',
    payQuote: quotesBaseUrl + 'PayQuote',
    processCheckout: quotesBaseUrl + "ProcessCheckout",
    removeByCustomer: (customerId: number, quoteId: number) => quotesBaseUrl + `DeleteByCustomer/${encodeURIComponent(customerId)}/${encodeURIComponent(quoteId)}`,
    updatePOAndFob: quotesBaseUrl + 'UpdatePoFob',
    updateDiscount: quotesBaseUrl + 'UpdateDiscount',
    updateItemDiscount: quotesBaseUrl + `UpdateItemDiscount`,
    updateItemComment: quotesBaseUrl + `UpdateItemComment`,
    sendEmail: quotesBaseUrl + 'SendOrderAsEmail',
    getMarginPreAuthPaymentsPercentageAmount: quotesBaseUrl + "GetMarginPreAuthPaymentsPercentageAmount",
}

/**
 * Sales Orders Apis.
 */
const saleOrdersBaseUrl = apiUrl + 'SaleOrders/';
export const salesOrdersApis = {
    baseUrl: saleOrdersBaseUrl,
    search: saleOrdersBaseUrl + 'Search',
    searchItems: saleOrdersBaseUrl + 'SearchItems',
    getForCustomer: (customerId: number, saleOrderId: number) => saleOrdersBaseUrl + `GetFullDetailsByCustomers/${encodeURIComponent(customerId)}/${encodeURIComponent(saleOrderId)}`,
    update: saleOrdersBaseUrl + `UpdateItems`,
    paySalesOrder: saleOrdersBaseUrl + 'PaySalesOrder',
    revertToQuoteByCustomer: (customerId: number, saleOrderId: number) => saleOrdersBaseUrl + `RevertToQuoteByCustomer/${encodeURIComponent(customerId)}/${encodeURIComponent(saleOrderId)}`,
    getInventorySerialNumbers: (warehouseCode: string, partNo: string) => saleOrdersBaseUrl + `GetAllInventorySerialNumbers?warehouseCode=${encodeURIComponent(warehouseCode)}&partNo=${encodeURIComponent(partNo)}&isNewAPI=true`,
    updatePartSerialNumbers: saleOrdersBaseUrl + 'UpdateSaleOrderSerialNumbersListByPart',
    updateCommittedQuantityOfPart: saleOrdersBaseUrl + 'UpdateSaleOrderCommitByNotSerializablePart',
    updateItems: saleOrdersBaseUrl + 'UpdateItems',
    updateAddress: saleOrdersBaseUrl + 'UpdateAddress',
    processCheckout: saleOrdersBaseUrl + `CheckoutToInvoice`,
    updatePOAndFob: saleOrdersBaseUrl + 'UpdatePoFob',
    updateItemComment: saleOrdersBaseUrl + 'UpdateItemComment',
    sendEmail: saleOrdersBaseUrl + 'SendOrderAsEmail',
    removeTransactionItem: saleOrdersBaseUrl + 'RemovePaymentTransactionItem',

}

/**
 * Back Orders Apis.
 */
const backOrdersBaseUrl = apiUrl + 'SaleOrders/';
export const backOrdersApis = {
    baseUrl: backOrdersBaseUrl,
    search: backOrdersBaseUrl + 'SearchBackOrders',
    searchItems: backOrdersBaseUrl + 'SearchBackOrderItems',
}

/**
 * Invoices Apis.
 */
const invoicesBaseUrl = apiUrl + 'Invoice/';
export const invoicesApis = {
    baseUrl: invoicesBaseUrl,
    search: invoicesBaseUrl + 'Search',
    searchItems: invoicesBaseUrl + 'SearchItems',
    get: (userId: number, invoiceId: number) => invoicesBaseUrl + `GetFullDetails/${encodeURIComponent(userId)}/${encodeURIComponent(invoiceId)}`,
    getForCustomer: (customerId: number, invoiceId: number) => invoicesBaseUrl + `GetFullDetailsByCustomer/${encodeURIComponent(customerId)}/${encodeURIComponent(invoiceId)}`,
    addCreditToMulti: invoicesBaseUrl + `AddCreditToMultipleInvoices`,
    payMultiInvoices: invoicesBaseUrl + `PayUserInvoices`,
    removeTransactionItem: invoicesBaseUrl + 'RemoveTransactionItem',
    payInvoice: invoicesBaseUrl + 'PayUserInvoice',
    addCreditToInvoice: invoicesBaseUrl + 'AddCreditToInvoice',
    removeBulkTransactionItem: invoicesBaseUrl + 'RemoveBulkTransactionItems',
    sendEmail: invoicesBaseUrl + 'SendOrderAsEmail',
    sendMultiEmail: invoicesBaseUrl + 'SendMultipleOrdersDetailsAsEmail',
    updatePoReference: invoicesBaseUrl + 'UpdatePoReference',
    updateItemComment: invoicesBaseUrl + 'UpdateItemComment',
}

/**
 * Credits Apis
 */
const creditsBaseUrl = apiUrl + 'Credit/';
export const creditsApis = {
    baseUrl: creditsBaseUrl,
    search: creditsBaseUrl + 'Search',
    searchItems: creditsBaseUrl + 'SearchItems',
    getForCustomer: (customerId: number, creditId: number) => creditsBaseUrl + `GetFullDetailsByCustomer/${encodeURIComponent(customerId)}/${encodeURIComponent(creditId)}`,
}

/**
 * Shopping Cart Apis.
 */
const shoppingCartBaseUrl = apiUrl + 'UserCarts/';
export const shoppingCartApis = {
    baseUrl: shoppingCartBaseUrl,
    getActiveCart: (userId: number) => shoppingCartBaseUrl + `GetCurrentActiveCart/${encodeURIComponent(userId)}`,
    closeShoppingCart: (userId: number) => shoppingCartBaseUrl + `SaveForLater/${encodeURIComponent(userId)}`,
    removeGiftCard: shoppingCartBaseUrl + `RemoveTransactionItem`,
    updateItems: shoppingCartBaseUrl + `UpdateCartItems`,
}


/**
 * Search Limit Apis.
 */
const searchLimitsBaseUrl = apiUrl + 'UserSearchLimits/';
export const searchLimitsApis = {
    baseUrl: searchLimitsBaseUrl,
    createLimit: searchLimitsBaseUrl,
    updateLimit: searchLimitsBaseUrl,
    removeLimit: (limitId: number) => searchLimitsBaseUrl + `${encodeURIComponent(limitId)}`,
}


/**
 * Operator (Staff) Apis
 */
const operatorBaseUrl = apiUrl + 'Staff/'
export const operatorApis = {
    baseUrl: operatorBaseUrl,
    getById: (staffId: string) => operatorBaseUrl + `GetUserById/${encodeURIComponent(staffId)}`,
    searchLocal: operatorBaseUrl + `SearchLocal`,
    createOperator: operatorBaseUrl,
    createOperatorGroup: operatorBaseUrl + `CreateNewUserGroup`,
    updateOperator: operatorBaseUrl,
    updateOperatorGroups: operatorBaseUrl + `UpdateUserGroups`,
    updateGroup: operatorBaseUrl + `UpdateGroup`,
    getAllOperatorGroups: operatorBaseUrl + `GetAllUserGroups`,
    getOperatorGroupById: (operatorGroupId: number) => operatorBaseUrl + `GetUserGroupById/${encodeURIComponent(operatorGroupId)}`,
    getAllAccessLevels: operatorBaseUrl + `GetAllAplicationAccessLevels`,
    addNewAccessLevel: operatorBaseUrl + `AddNewAccessLevelsToUserGroup`,
    removeAccessLevel: operatorBaseUrl + `RemoveAccessLevels`,
    resetPassword: operatorBaseUrl + "ResetOperatorPassword",
    getCurrentOperatorInformation: operatorBaseUrl + "GetCurrentUser",
    resetCurrentOperatorPassword: operatorBaseUrl + "UpdatePassword"
}

/**
 * Price Matrix Apis.
 */
const priceMatrixBaseUrl = apiUrl + 'PriceMatrix/';
export const priceMatrixApis = {
    getSystemPriceMatrices: priceMatrixBaseUrl,
    getCustomerPriceMatrices: (customerId?: number) => priceMatrixBaseUrl + `GetByCustomerId/${customerId}`,
    create: priceMatrixBaseUrl,
    update: priceMatrixBaseUrl,
    remove: (priceMatrixId: number) => priceMatrixBaseUrl + `${priceMatrixId}`,
}


/**
 * PartSupport (Warranty And Return) Apis
 */
const warrantyAndReturnBaseUrl = apiUrl + 'PartSupportReq/';
export const warrantyAndReturnApis = {
    baseUrl: warrantyAndReturnBaseUrl,
    assignToOperator: (warrantyId: number) => warrantyAndReturnBaseUrl + `AssignTheRequestToCurrentOperator/${encodeURIComponent(warrantyId)}`,
    assignToVendor: warrantyAndReturnBaseUrl + `AssignVendorToPartSupportReq`,
    getInformation: (warrantyId: number) => warrantyAndReturnBaseUrl + `GetFullInfoById/${encodeURIComponent(warrantyId)}`,
    submitInitialRequest: warrantyAndReturnBaseUrl,
    getStatusesAndTypes: warrantyAndReturnBaseUrl + `ListOfTypeAndStatus`,
    sendMessage: warrantyAndReturnBaseUrl + `SendMessageToUserChat`,
    deleteMessage: (messageId: number) => warrantyAndReturnBaseUrl + `DeleteMessage/${messageId}`,
    changeStatus: (requestId: number, statusId: number, reasonId: number) => warrantyAndReturnBaseUrl + `ChangeStatus/${encodeURIComponent(requestId)}/${encodeURIComponent(statusId)}${reasonId ? `/${encodeURIComponent(reasonId)}` : ''}`,
    submitRequestNewExpirationDate: warrantyAndReturnBaseUrl + `SubmitRequestNewExpirationDate`,
    validateRGA: (rga: string) => warrantyAndReturnBaseUrl + `ValidateRGA/${encodeURIComponent(rga)}`,
    updateRga: warrantyAndReturnBaseUrl + 'UpdateRGA',
    remove: (id: number) => warrantyAndReturnBaseUrl + `RemoveRequest/${encodeURIComponent(id)}`,
    getProcessEditPageData: warrantyAndReturnBaseUrl + 'GetPartSupportRequestProcessEditPageData',
    assignCredit: warrantyAndReturnBaseUrl + 'AssignCreditToPartSupportReq',
    removeVendor: warrantyAndReturnBaseUrl + 'RemoveVendorFromPartSupportRequest',
    updateRequest: warrantyAndReturnBaseUrl,
    detachCredit: warrantyAndReturnBaseUrl + 'DetachCreditFromPartSupportReq',
    detachVendorCredit: warrantyAndReturnBaseUrl + 'DetachVendorCreditFromPartSupportReq',
    assignVendorCredit: warrantyAndReturnBaseUrl + 'AssignVendorCreditToPartSupportReq',
    updateNote: warrantyAndReturnBaseUrl + 'UpdateNote',
    //Changed the url path of the api as the keyword should be in query param format
    searchVendorCredits: (id: number, keywords?: string) => warrantyAndReturnBaseUrl + `GetAllVendorNegativePurchasesByRequest/${id}` + (!!keywords ? `?keyword=${encodeURIComponent(keywords)}` : ''),
}

/**
 * Partner configuration catalog / values (CleanAF-style singular controller).
 */
const partnerConfigurationBaseUrlV2 = apiUrl + 'CleanAF/PartnerConfiguration/';
export const partnerConfigurationApisV2 = {
    baseUrl: partnerConfigurationBaseUrlV2,
    list: partnerConfigurationBaseUrlV2 + 'List',
    getValues: partnerConfigurationBaseUrlV2 + 'GetValues',
    setPartner: partnerConfigurationBaseUrlV2 + 'SetPartner',
    setOperator: partnerConfigurationBaseUrlV2 + 'SetOperator',
}

/**
 * Legacy PartnerConfigurations endpoints still in use (print token only).
 */
const partnerConfigurationsBaseUrl = apiUrl + 'PartnerConfigurations/';
export const partnerConfigurationsApis = {
    baseUrl: partnerConfigurationsBaseUrl,
    getPrintApplicationToken: partnerConfigurationsBaseUrl + 'GetPrintApplicationToken',
}

/**
 * Warehouse Apis
 */
const warehouseBaseUrl = apiUrl + 'SpireWarehouses/';
export const warehouseApis = {
    baseUrl: warehouseBaseUrl,
    getAll: warehouseBaseUrl,
}

/**
 * Warehouse v2 Apis (CleanAF)
 */
const warehouseV2BaseUrl = apiUrl + 'CleanAF/Warehouse';
export const warehouseV2Apis = {
    baseUrl: warehouseV2BaseUrl,
    readAll: warehouseV2BaseUrl + '/ReadAllWarehouse',
}

/**
 * Transaction Credit Apis
 */
const transactionCreditsBaseUrl = apiUrl + 'TransactionCredits/';
export const transactionCreditsApi = {
    baseUrl: transactionCreditsBaseUrl,
    getAllAvailableCreditByCustomer: (customerId: number) => transactionCreditsBaseUrl + `GetAllAvailableCreditByCustomer/${encodeURIComponent(customerId)}`,
    getAllTransactionsDetailsOfOrder: (orderId: number, type: string) => transactionCreditsBaseUrl + `GetAllTransactionsDetailsOfOrder?id=${encodeURIComponent(orderId)}&Type=${encodeURIComponent(type)}`,
}

/**
 * Dashboard Apis
 */
const dashboardBaseUrl = apiUrl + 'Dashboard/';
export const dashboardApis = {
    baseUrl: dashboardBaseUrl,
    getAllGroupsWithAssignedDashboards: dashboardBaseUrl + 'GetAllGroupsWithAssignedDashboards',
    removeDashboardFromGroup: (dashboardId: number, groupId: number) => dashboardBaseUrl + `RemoveDashboardFromGroup/${encodeURIComponent(dashboardId)}/${encodeURIComponent(groupId)}`,
    addDashboardToGroup: (dashboardId: number, groupId: number) => dashboardBaseUrl + `AddDashboardToGroup/${encodeURIComponent(dashboardId)}/${encodeURIComponent(groupId)}`,
    getOperatorDashboards: (report: boolean) => dashboardBaseUrl + 'GetUserDashboards' + (report ? "?type=Report" : ""),
    setDefault: (dashboardId: number) => dashboardBaseUrl + `SetDefault/${encodeURIComponent(dashboardId)}`,
    getPublicDashboards: dashboardBaseUrl + `GetPublicDashboards?typeId=1`,
    getPublicReports: dashboardBaseUrl + `GetPublicDashboards?typeId=2}`
}

/**
 * Addresses Apis
 */
const addressesBaseUrl = apiUrl + 'Addresses/';
export const addressesApis = {
    baseUrl: addressesBaseUrl,
    getAllCountries: addressesBaseUrl + `GetAllCountries`,
    getAllProvincesForCountry: (countryId: number) => addressesBaseUrl + `GetAllProvinces/${encodeURIComponent(countryId)}`,
}

/**
 * Biz Live Apis
 */
const bizLiveBaseUrl = apiUrl + 'Live/';
export const bizLiveApis = {
    baseUrl: bizLiveBaseUrl,
    getUnreadCount: bizLiveBaseUrl + 'GetUnreadMessagesCount',
    getNotifications: bizLiveBaseUrl + 'GetMessages',
    deactivateFirebaseDevice: bizLiveBaseUrl + 'DeactivateFirebaseLink',
    submitFirebaseDevice: bizLiveBaseUrl + `SubmitFirebaseDevice`,
    getNotificationTypes: bizLiveBaseUrl + 'GetNotificationsTypes',
    sendNotification: bizLiveBaseUrl + 'SendDirectNotificationToUser',
    searchSentNotifications: bizLiveBaseUrl + "SearchSentMessages",
    searchReceivedNotifications: bizLiveBaseUrl + "SearchUserNotifications",
    toggleRaedStatus: (id: number) => bizLiveBaseUrl + `ToggleReadStatus/${encodeURIComponent(id)}`,
    markAllAsRead: bizLiveBaseUrl + `MarkAllAsRead`,
    toggleSavedStatus: (id: number) => bizLiveBaseUrl + `ToggleSave/${encodeURIComponent(id)}`,
    setCategoryForNotification: bizLiveBaseUrl + `SetCategoryForNotification`,
    getNotificationCategories: bizLiveBaseUrl + `GetAllCategories`,
    createNotificationCategory: bizLiveBaseUrl + 'CreateNewCategory',
    updateNotificationCategory: bizLiveBaseUrl + 'UpdateCategory',
    updateNotificationCategoriesOrder: bizLiveBaseUrl + 'UpdateCategoriesSortOrder',
    removeNotificationCategory: (id: number) => bizLiveBaseUrl + `DeleteCategory/${encodeURIComponent(id)}`,
}

/**
 * Part Support Vendors Msg Apis
 */
const partSupportVendorsMsgBaseUrl = apiUrl + 'PartSupportVendorsMsg/';
export const partSupportVendorsMsgApis = {
    baseUrl: partSupportVendorsMsgBaseUrl,
    resetVendorChatAccessLink: (requestId: number) => partSupportVendorsMsgBaseUrl + `ResetVendorChatAccessLink/${encodeURIComponent(requestId)}`,
    getMessages: (requestId: number) => partSupportVendorsMsgBaseUrl + `GetAllVendorMessages/${encodeURIComponent(requestId)}`,
    sendMessage: partSupportVendorsMsgBaseUrl + `sendMessage`,
    forwardUserChatMessage: partSupportVendorsMsgBaseUrl + 'ForwardUserChatMessage',
    deleteMessage: (messageId: number) => partSupportVendorsMsgBaseUrl + `RemoveMessage/${encodeURIComponent(messageId)}`,
}

/**
 * Vendors Apis
 */
const vendorsBaseUrl = apiUrl + 'Vendors/';
export const vendorsApis = {
    baseUrl: vendorsBaseUrl,
    search: vendorsBaseUrl + 'search',
    getVendorInformation: (vendorCode: string) => vendorsBaseUrl + `GetVendorOnlineProfile/${encodeURIComponent(vendorCode)}`,
    getVendorSuggestions: (partNo: string) => vendorsBaseUrl + `SuggestVendors?partNo=${encodeURIComponent(partNo)}&isNewAPI=true`,
    createOnlineProfile: vendorsBaseUrl + 'CreateOnlineProfile',
}

/**
 * CMS Apis
 */
const cmsBaseUrl = apiUrl + 'Cms/';
export const cmsApis = {
    baseUrl: cmsBaseUrl,
    getCategoriesByType: (type: string) => cmsBaseUrl + `Categories/${encodeURIComponent(type)}`,
    searchBlogs: cmsBaseUrl + 'Posts/Search',
    getBlogBySlug: (slug: string) => cmsBaseUrl + `Posts/${encodeURIComponent(slug)}`,
    searchVideos: cmsBaseUrl + 'Videos/Search',
    getVideoBySlug: (slug: string) => cmsBaseUrl + `Videos/${encodeURIComponent(slug)}`,
}

/**
 * SalesPerson Apis
 */
const salesPersonBaseUrl = apiUrl + 'SalesPerson/';
export const salesPersonApis = {
    baseUrl: salesPersonBaseUrl,
    getProfile: salesPersonBaseUrl,
    createProfile: salesPersonBaseUrl,
}

/**
 * SalesPerson Apis
 */
const versionHistoryBaseUrl = apiUrl + 'VersionHistory/';
export const versionHistoryApis = {
    baseUrl: versionHistoryBaseUrl,
    get: versionHistoryBaseUrl + 'Web',
    getLatest: versionHistoryBaseUrl + 'GetLatest',
    readLatest: versionHistoryBaseUrl + 'MarkVersionAsRead',
}

/**
 * Warranty and Return Template Upload Apis
 */
const partSupportReqUploadFilesBaseUrl = apiUrl + 'PartSupportReqUploadFiles/';
export const partSupportReqUploadFilesApis = {
    baseUrl: partSupportReqUploadFilesBaseUrl,
    getTemplateFiles: (requestId: number) => partSupportReqUploadFilesBaseUrl + `GetUploadFilePageData?partSupportReqId=${encodeURIComponent(requestId)}`,
    upload: partSupportReqUploadFilesBaseUrl + 'UploadNewTemplateForRequest',
    remove: partSupportReqUploadFilesBaseUrl + 'RemoveUploadedDocument',
    submitTemplate: (requestId: number) => partSupportReqUploadFilesBaseUrl + `SubmitToTheNextStep?partSupportReqId=${encodeURIComponent(requestId)}`,
    submitTemplateWithUser: (requestId: number, userId: number) => partSupportReqUploadFilesBaseUrl + `SubmitToTheNextStep/${encodeURIComponent(userId)}/${encodeURIComponent(requestId)}`
}

/**
 * Order note Apis
 */
const orderNotesBaseUrl = apiUrl + 'UserOrderNotes';
export const orderNotesApis = {
    baseUrl: orderNotesBaseUrl,
    getAll: (orderNo: string) => orderNotesBaseUrl + `?orderNo=${encodeURIComponent(orderNo)}`,
    getTypes: orderNotesBaseUrl + '/GetAllNoteTypes',
    getPrintPlaces: orderNotesBaseUrl + '/GetAllPrintPlaces',
    create: orderNotesBaseUrl,
    update: orderNotesBaseUrl,
    remove: (id: number) => orderNotesBaseUrl + `/${id}`,
}

/**
 * part support request Statuses Apis
 */
const partSupportRequestStatusesBaseUrl = apiUrl + 'PartSupportRequestStatusAndReason/';
export const partSupportRequestStatusesApis = {
    baseUrl: partSupportRequestStatusesBaseUrl,
    getAll: partSupportRequestStatusesBaseUrl + `ListOfTypeAndStatusForEdit`,
    updateStatus: partSupportRequestStatusesBaseUrl + `UpdatePartSupportReqStatus`,
    createStatus: partSupportRequestStatusesBaseUrl + `AddNewPartSupportReqStatus`,
    updateReason: partSupportRequestStatusesBaseUrl + `UpdatePartSupportReqStatusReason`,
    createReason: partSupportRequestStatusesBaseUrl + `AddNewPartSupportReqStatusReason`,
}

/**
 * user Event Subscriptions Apis
 */
const operatorChannelSubscriptionsBaseUrl = apiUrl + 'OperatorChannelSubscriptions/';
export const operatorChannelSubscriptionApis = {
    baseUrl: operatorChannelSubscriptionsBaseUrl,
    getAllAvailableChannels: operatorChannelSubscriptionsBaseUrl + 'GetAllAvailableChannels',
    getOperatorChannelsSubscriptionPageData: operatorChannelSubscriptionsBaseUrl + `GetOperatorChannelsSubscriptionPageData`,
    subscribe: operatorChannelSubscriptionsBaseUrl + "Subscribe",
    unsubscribe: operatorChannelSubscriptionsBaseUrl + "Unsubscribe",
}

/**
 * Notification Channel Apis
 */
const notificationChannelsBaseUrl = apiUrl + 'NotificationChannels/';
export const notificationChannelApis = {
    baseUrl: notificationChannelsBaseUrl,
    getAllChannelsEditPageData: notificationChannelsBaseUrl + `GetAllChannelsEditPageData`,
    addNewGroupToChannel: notificationChannelsBaseUrl + `AddNewGroupToChannel`,
    removeGroupFromChannel: notificationChannelsBaseUrl + `RemoveGroupFromChannel`,
}

/**
 * Part Support Request File Template Apis
 */
const partSupportReqFileTemplateBaseUrl = apiUrl + 'PartSupportReqFileTemplate/';
export const partSupportReqFileTemplateApis = {
    baseUrl: partSupportReqFileTemplateBaseUrl,
    create: partSupportReqFileTemplateBaseUrl,
    edit: partSupportReqFileTemplateBaseUrl,
    remove: (id: number) => partSupportReqFileTemplateBaseUrl + `${id}`,
}

/**
 * Part Support Request Applicability Apis
 */
const partSupportReqApplicabilityBaseUrl = apiUrl + 'PartSupportReqApplicability/';
export const partSupportReqApplicabilityApis = {
    baseUrl: partSupportReqApplicabilityBaseUrl,
    create: partSupportReqApplicabilityBaseUrl,
    edit: partSupportReqApplicabilityBaseUrl,
    remove: (id: number) => partSupportReqApplicabilityBaseUrl + `${id}`,
}

/**
 * Part Support Request Extra Fees Apis
 */
const partSupportReqExtraFeesBaseUrl = apiUrl + 'PartSupportReqExrtaFee/';
export const partSupportReqExtraFeesApis = {
    baseUrl: partSupportReqExtraFeesBaseUrl,
    create: partSupportReqExtraFeesBaseUrl,
    edit: partSupportReqExtraFeesBaseUrl,
    remove: (id: number) => partSupportReqExtraFeesBaseUrl + `${id}`,
}

/**
 * Part Support Request Extra Fees Titles Apis
 */
const partSupportReqExtraFeesTitleBaseUrl = apiUrl + 'PartSupportExtraFeeTitle/';
export const partSupportReqExtraFeesTitleApis = {
    baseUrl: partSupportReqExtraFeesTitleBaseUrl,
    get: partSupportReqExtraFeesTitleBaseUrl,
    create: partSupportReqExtraFeesTitleBaseUrl,
    edit: partSupportReqExtraFeesTitleBaseUrl,
    remove: (id: number) => partSupportReqExtraFeesTitleBaseUrl + `${id}`,
}

/**
 * Operator part Apis
 */
const operatorPartBaseUrl = apiUrl + 'OperatorPart/';
export const operatorPartApis = {
    baseUrl: operatorPartBaseUrl,
    getPartFullInfo: (id: number) => operatorPartBaseUrl + `GetPartFullInfo/${encodeURIComponent(id)}`,
    updateUPC: operatorPartBaseUrl + 'UpdateUPC',
    updateCategory: operatorPartBaseUrl + 'UpdateCategory',
    updateOrAddFullDescription: operatorPartBaseUrl + 'UpdateOrAddFullDescription',
    updateShortDescription: operatorPartBaseUrl + 'UpdateShortDescription',
}

/**
 * Operator part Note Apis
 */
const operatorPartNoteBaseUrl = apiUrl + 'OperatorPartNote/';
export const operatorPartNoteApis = {
    baseUrl: operatorPartNoteBaseUrl,
    getByPartId: (id: number) => operatorPartNoteBaseUrl + `GetByPartId/${encodeURIComponent(id)}`,
    create: operatorPartNoteBaseUrl,
    edit: operatorPartNoteBaseUrl,
    remove: (id: number) => operatorPartNoteBaseUrl + `${encodeURIComponent(id)}`,
}

/**
 * Operator part Image Apis
 */
const operatorPartImageBaseUrl = apiUrl + 'OperatorPartImage/';
export const operatorPartImageApis = {
    baseUrl: operatorPartImageBaseUrl,
    getByPartId: (id: number) => operatorPartImageBaseUrl + `${encodeURIComponent(id)}`,
    create: operatorPartImageBaseUrl,
    updateImagesOrder: operatorPartImageBaseUrl + `UpdateImagesOrder`,
    setDefaultCoverImage: (id: number) => operatorPartImageBaseUrl + `SetDefaultCoverImage/${encodeURIComponent(id)}`,
    remove: (id: number) => operatorPartImageBaseUrl + `${encodeURIComponent(id)}`,
}

/**
 * Operator part Technical File Apis
 */
const operatorPartTechnicalFileBaseUrl = apiUrl + 'OperatorPartTechnicalFile/';
export const operatorPartTechnicalFileApis = {
    baseUrl: operatorPartTechnicalFileBaseUrl,
    getByPartId: (id: number) => operatorPartTechnicalFileBaseUrl + `GetByPartId/${encodeURIComponent(id)}`,
    getHistoryById: (id: string) => operatorPartTechnicalFileBaseUrl + `GetHistoryById?documentId=${encodeURIComponent(id)}`,
    removeLastVersion: (id: string) => operatorPartTechnicalFileBaseUrl + `RemoveLastVersion?documentId=${encodeURIComponent(id)}`,
    remove: (id: string) => operatorPartTechnicalFileBaseUrl + `RemoveDocument?documentId=${encodeURIComponent(id)}`,
    create: operatorPartTechnicalFileBaseUrl + `AddNewDocument`,
    uploadNewVersion: operatorPartTechnicalFileBaseUrl + `UploadNewVersion`,
    updateDocumentInfo: operatorPartTechnicalFileBaseUrl + `UpdateDocumentInfo`,
    setVersionToCurrentVersion: operatorPartTechnicalFileBaseUrl + `SetVersionToCurrentVersion`,
    searchAssignedParts: operatorPartTechnicalFileBaseUrl + `SearchAssignedParts`,
    assignPartsToDocument: operatorPartTechnicalFileBaseUrl + `AssignPartToDocuments`,
}

/**
 * Operator part Feedback Apis
 */
const operatorPartFeedbackBaseUrl = apiUrl + 'OperatorPartFeedback/';
export const operatorPartFeedbackApis = {
    baseUrl: operatorPartFeedbackBaseUrl,
    getByPartId: (id: number) => operatorPartFeedbackBaseUrl + `GetByPartId/${encodeURIComponent(id)}`,
    remove: (id: number) => operatorPartFeedbackBaseUrl + `${encodeURIComponent(id)}`,
}

/**
 * Operator part relation Apis
 */
const operatorPartRelationBaseUrl = apiUrl + 'OperatorPartRelation/';
export const operatorPartRelationApis = {
    baseUrl: operatorPartRelationBaseUrl,
    getByPartId: (id: number) => operatorPartRelationBaseUrl + `GetByPartId/${encodeURIComponent(id)}`,
    getAllRelationTypes: operatorPartRelationBaseUrl + `GetAllRelationTypes`,
    remove: operatorPartRelationBaseUrl + `Remove`,
    create: operatorPartRelationBaseUrl + `AddNew`,
}

const partRelationTypesBaseUrl = apiUrl + 'PartRelationType';
export const partRelationTypes = {
    baseUrl: partRelationTypesBaseUrl,
    deletePartRelationType: (partRelationId: number) => partRelationTypesBaseUrl + `/${partRelationId}`,
}

/**
 * Operator part Tag Apis
 */
const operatorPartTagBaseUrl = apiUrl + 'OperatorPartTag/';
export const operatorPartTagApis = {
    baseUrl: operatorPartTagBaseUrl,
    addNewToPart: operatorPartTagBaseUrl + `AddNewTagToPart`,
    removeFromPart: operatorPartTagBaseUrl + `RemoveTag`,
}

/**
 * Operator part Technical file share link Apis
 */
const operatorPartTechnicalFileShareLinkBaseUrl = apiUrl + 'OperatorPartTechnicalFileShareLink/';
export const operatorPartTechnicalFileShareLink = {
    baseUrl: operatorPartTechnicalFileShareLinkBaseUrl,
    getAllByDocument: (id: string, partNo: string) => operatorPartTechnicalFileShareLinkBaseUrl + `GetAllByDocument?documentId=${encodeURIComponent(id)}&partNo=${encodeURIComponent(partNo)}`,
    create: operatorPartTechnicalFileShareLinkBaseUrl,
    remove: (id: number) => operatorPartTechnicalFileShareLinkBaseUrl + `${encodeURIComponent(id)}`,
}

const partFileBaseUrl = apiUrl + 'PartFile';
export const partFileApis = {
    updateTechnicalFileShareLinkTitle: partFileBaseUrl + '/UpdatePartFileShareTitle',
    unAssignItemsFromTechnicalFile: partFileBaseUrl + '/UnassignPartsFromDocument',
}

/**
 * Operator part application suggestion api
 */
const operatorPartApplicationSuggestionBaseUrl = apiUrl + 'ApplicationSuggestion';
export const operatorPartApplicationSuggestion = {
    baseUrl: operatorPartApplicationSuggestionBaseUrl,
    suggestNewApplication: operatorPartApplicationSuggestionBaseUrl,
    changeStatusOfApplicationSuggestion: operatorPartApplicationSuggestionBaseUrl + '/ChangeStatus',
    getListOfApplicationSuggestions: operatorPartApplicationSuggestionBaseUrl + '/List'
}

/**
 * Operator part technical suggestion api
 */
const operatorPartTechnicalSuggestionBaseUrl = apiUrl + 'TechnicalSuggestion';
export const operatorTechnicalSuggestion = {
    baseUrl: operatorPartTechnicalSuggestionBaseUrl,
    changeStatusOfTechnicalSuggestion: operatorPartTechnicalSuggestionBaseUrl + '/ChangeStatus',
    getListOfTechnicalSuggestions: operatorPartTechnicalSuggestionBaseUrl + '/List',
}

/**
 * Operator part prices api
 */
const operatorPartPriceBaseUrl = apiUrl + 'PartPrice';
export const operatorPartPrice = {
    baseUrl: operatorPartPriceBaseUrl,
    getLivePriceLevels: (partId: number) => operatorPartPriceBaseUrl + `?partId=${partId}`,
    getListOfPreviousPriceLevels: (partId: number) => operatorPartPriceBaseUrl + `/GetLogs/${partId}`,
    getPreviousPriceLevelFullDetails: operatorPartPriceBaseUrl + `/GetLogDetails`,
    updatePartPrice: operatorPartPriceBaseUrl,
    generateReportOfPartPriceLevels: operatorPartPriceBaseUrl + '/GenerateReport',
    setPrice: operatorPartPriceBaseUrl + '/SetPrice'
}

/**
 * Budget Apis
 */
const budgetBaseUrl = apiUrl + 'budget/';
export const budgetApis = {
    baseUrl: budgetBaseUrl,
    getAllActives: budgetBaseUrl + `GetAllActives`,
    getBudgetHistory: budgetBaseUrl + 'GetBudgetHistory',
    create: budgetBaseUrl,
    update: budgetBaseUrl,
    remove: (id: number) => budgetBaseUrl + `${encodeURIComponent(id)}`,
    redeem: budgetBaseUrl + `RedeemCoupon`,
    getUserRedeemHistory: budgetBaseUrl + 'GetUserRedeemHistory',
    validatePromoCode: (code: string) => budgetBaseUrl + `ValidateTitle?code=${encodeURIComponent(code)}`
}

/**
 * User Payments Apis
 */
const userPaymentsBaseUrl = apiUrl + "UserPayments/";
export const userPaymentsApis = {
    baseUrl: userPaymentsBaseUrl,
    getAllAvailablePaymentMethods: userPaymentsBaseUrl + `GetAllAvailablePaymentMethods`,
}

/**
 * Partner Apis
 */
const partnerBaseUrl = apiUrl + "Partner";
export const partnerApis = {
    baseUrl: partnerBaseUrl,
    getInformation: partnerBaseUrl,
    getPriceLevels: partnerBaseUrl + '/GetPriceLevels',
    updateSalesRegulation: partnerBaseUrl + '/UpdateSalesRegulation',
    setPartnerOperationHours: partnerBaseUrl + '/SetPartnerOperationHours',
    getPartnerOperationHours: partnerBaseUrl + '/GetPartnerOperationHours',
    updatePartnerBasicInfo: partnerBaseUrl + '/UpdatePartnerBasicInfo',
    removePartnerOperationHours: (id: number) => partnerBaseUrl + `/DeletePartnerOperationHours?id=${encodeURIComponent(id)}`,
    getSpireConnection: partnerBaseUrl + '/GetSpireConnection',
    updateSpireConnection: partnerBaseUrl + '/UpdateSpireConnection',
    addNewPartner: partnerBaseUrl + '/AddNewPartner',
    getPartnerSetupCheckList: partnerBaseUrl + '/GetPartnerSetupCheckList',
    updatePartnerColor: partnerBaseUrl + '/UpdatePartnerColor',
    getPartnerRetailUser: partnerBaseUrl + '/GetPartnerRetailUser',
    updatePartnerRetailUser: partnerBaseUrl + '/UpdatePartnerRetailUser',
    getPartnersSalesPersonAndTerritory: partnerBaseUrl + '/GetPartnersSalesPersonAndTerritory',
    updatePartnersSalesPersonAndTerritory: partnerBaseUrl + '/UpdatePartnersSalesPersonAndTerritory',
}

/**
 * Admin File uploader Apis.
 */
const adminFileUploaderBaseUrl = adminUrl + 'FileUploader/';
export const adminFileUploaderApis = {
    baseUrl: adminFileUploaderBaseUrl,
    uploadFile: adminFileUploaderBaseUrl + 'upload',
    uploadFileByContent: adminFileUploaderBaseUrl + 'UploadByContent',
}

/**
 * Quote Bypass Apis.
 */
const quoteBypassBaseUrl = apiUrl + 'QuoteByPass/';
export const quoteBypassApis = {
    baseUrl: quoteBypassBaseUrl,
    get: (id: number) => quoteBypassBaseUrl + `${encodeURIComponent(id)}`,
    create: quoteBypassBaseUrl.slice(0, quoteBypassBaseUrl.length - 1),
    remove: (id: number) => quoteBypassBaseUrl + `${encodeURIComponent(id)}`,
}

/**
 * Quote Bypass Reason Apis.
 */
const quoteBypassReasonBaseUrl = apiUrl + 'QuoteByPassReason/';
export const quoteBypassReasonApis = {
    baseUrl: quoteBypassReasonBaseUrl,
    getAll: quoteBypassReasonBaseUrl.slice(0, quoteBypassReasonBaseUrl.length - 1),
    create: quoteBypassReasonBaseUrl.slice(0, quoteBypassReasonBaseUrl.length - 1),
    update: quoteBypassReasonBaseUrl.slice(0, quoteBypassReasonBaseUrl.length - 1),
    remove: (id: number) => quoteBypassReasonBaseUrl + `${encodeURIComponent(id)}`,
}

/**
 * Quote Bypass Rule Apis.
 */
const quoteBypassRuleBaseUrl = apiUrl + 'QuoteByPassRule/';
export const quoteBypassRuleApis = {
    baseUrl: quoteBypassRuleBaseUrl,
    saveNewRule: quoteBypassRuleBaseUrl.slice(0, quoteBypassRuleBaseUrl.length - 1),
    get: (id: number) => quoteBypassRuleBaseUrl + `${encodeURIComponent(id)}`,
}

/**
 * Error Handling Apis.
 */
const errorHandlingBaseUrl = apiUrl + 'ErrorHandling';
export const errorHandlingApis = {
    baseUrl: errorHandlingBaseUrl,
    reportError: errorHandlingBaseUrl,
}

/**
 * Main page Apis.
 */
const userHomepageBaseUrl = apiUrl + 'MainPage';
export const userHomepageApis = {
    baseUrl: userHomepageBaseUrl,
    getLiveMainPage: userHomepageBaseUrl,
}

/**
 * Tag Apis.
 */
const tagsBaseUrl = apiUrl + 'Tags';
export const tagApis = {
    createTag: tagsBaseUrl,
    deleteTagsFromSystem: tagsBaseUrl,
    updateTagInformation: tagsBaseUrl,
    getByIds: tagsBaseUrl + '/GetByIds',
    autoFill: (keywords: string, industryId?: string) => tagsBaseUrl + `/Autofill?keyword=${!!keywords?.trim() ? encodeURIComponent(keywords.trim()) : ''}${!industryId ? '' : `&industryId=${encodeURIComponent(industryId)}`}`,
    search: tagsBaseUrl + '/Filter',
    getTagFullInformation: (tagId: number) => tagsBaseUrl + `/GetFullInfo/${encodeURIComponent(tagId)}`,
    getTagConnectedParts: tagsBaseUrl + '/GetRelatedParts',
    deleteTagFromBanner: (connectionId: number) => tagsBaseUrl + `/DeleteTagBannerConnection/${encodeURIComponent(connectionId)}`,
    getByPartId: (productId: number) => tagsBaseUrl + `/GetByPartId?partId=${encodeURIComponent(productId)}`,
    getStatistics: tagsBaseUrl + `/getStatistics`,
}

/**
 * Color theme Apis.
 */
const colorThemeBaseUrl = apiUrl + 'ColorTheme/';
export const colorThemeApis = {
    getList: colorThemeBaseUrl + 'List',
    setAsDefault: (id: number) => colorThemeBaseUrl + `SetDefault/${encodeURIComponent(id)}`,
    getDefault: colorThemeBaseUrl + 'GetDefault',
}

/**
 * Partners surveys apis
 */
const surveysBaseUrl = apiUrl + 'Survey';
export const surveysApis = {
    baseUrl: surveysBaseUrl,
    getListOfSurveys: (keyword: string) => (keyword && keyword.length) ? `${surveysBaseUrl}?keyword=${encodeURIComponent(keyword)}` : surveysBaseUrl,
    addSurvey: surveysBaseUrl,
    updateSurvey: surveysBaseUrl,
    deleteSurvey: (id: number) => surveysBaseUrl + `/${encodeURIComponent(id)}`
}

/**
 * Product information apis.
 */
const productInformationBaseUrl = apiUrl + 'PartInformation/';
export const productInformationApis = {
    baseUrl: productInformationBaseUrl,
    getProductTypes: productInformationBaseUrl + 'GetTypes',
    getProductCostHistoryReport: productInformationBaseUrl + 'GetCostLogs',
    toggleProductBeingSerialized: (partId: number) => productInformationBaseUrl + `ToggleSerializedStatus/${partId}`,
    toggleVisibility: (partId: number) => productInformationBaseUrl + `ToggleVisibility/${partId}`,
    setPartVisibleForClient: productInformationBaseUrl + `SetPartVisibleForClient`,
    setPartEligibleForOnlineOrdering: productInformationBaseUrl + 'SetPartEligibleForOnlineOrdering',
    updateProductCost: productInformationBaseUrl + 'UpdateCost',
    getFastConnectionData: productInformationBaseUrl + 'LoadFastConnection',
    validatePartNumbers: productInformationBaseUrl + 'ValidatePartNumbers',
    getPartInfoWithPartNumbers: productInformationBaseUrl + 'GetParts',
    setPartVisibility: productInformationBaseUrl + 'SetPartsVisibility',
    getPartKeyInfo: (partNo: string, warehouseCode?: string) => productInformationBaseUrl + `GetPartKeyInfo?partNumber=${encodeURIComponent(partNo)}${warehouseCode ? `&warehouseCode=${encodeURIComponent(warehouseCode)}` : ''}`,
    getAvailabilitiesV2: productInformationBaseUrl + `GetAvailabilities`,
    getPriceForCustomer: productInformationBaseUrl + `GetPriceForCustomer`,
    MarkPartsForCache: productInformationBaseUrl + `MarkPartsForCache`,
    setIsPublicForBuyers: productInformationBaseUrl + `SetIsPublicForBuyers`,
    createPartInWarehouse: productInformationBaseUrl + `CreatePartInWarehouse`,
    createPart: productInformationBaseUrl + `CreatePart`,
    copyFromPart: productInformationBaseUrl + `CopyFromPart`,
    getPartSections: productInformationBaseUrl + `GetPartSections`,
    makeVariantPart: productInformationBaseUrl + `MakeVariantPart`,
    removeVariant: productInformationBaseUrl + 'RemoveVariant',
    getProductVariant: productInformationBaseUrl + 'GetProductVariant',
    loadPartsByPrefix: (prefix: string) => productInformationBaseUrl + `LoadPartByPrefix?prefix=${encodeURIComponent(prefix)}`,
    updatePartNumber: productInformationBaseUrl + 'UpdatePartNumber',
    externalPartAutoFill: productInformationBaseUrl + `ExternalPartAutoFill`,
    importPartFromExternal: productInformationBaseUrl + `ImportPartFromExternal`,
    loadPartTaxes: (partId: number, warehouseCode: string) => productInformationBaseUrl + `LoadPartTax?partId=${encodeURIComponent(partId)}&warehouseCode=${encodeURIComponent(warehouseCode)}`,
    updatePartTax: productInformationBaseUrl + `UpdatePartTax`,
    assignPartCategoryByTitle: productInformationBaseUrl + `AssignPartCategoryByTitle`,
    listPartUpcs: (partId: number) => productInformationBaseUrl + `ListPartUpcs?partId=${encodeURIComponent(partId)}`,
    addPartUpc: productInformationBaseUrl + `AddPartUpc`,
    removePartUpc: productInformationBaseUrl + `RemovePartUpc`,
    updatePartUpc: productInformationBaseUrl + `UpdatePartUpc`,
    removePart: productInformationBaseUrl + `RemovePart`,
    updatePartTitle: productInformationBaseUrl + `UpdatePartTitle`,
    updatePartDeliveryMode: productInformationBaseUrl + 'UpdatePartDeliveryMode',
    checkFormQualificationForPart: (partId: number | string, customerId: number | string) => productInformationBaseUrl + `CheckFormQualificationForPart/${encodeURIComponent(String(partId))}/${encodeURIComponent(String(customerId))}`,
    getCrossSalesParts: (partId: number | string) => productInformationBaseUrl + `GetCrossSalesParts/${encodeURIComponent(String(partId))}`,
    exportParts: productInformationBaseUrl + 'ExportParts',
    copyPartFromSellerPartner: productInformationBaseUrl + 'CopyPartFromSellerPartner',
}

/**
 * inventory apis.
 */
const inventoryBaseUrl = apiUrl + 'Inventory';
export const inventoryApis = {
    baseUrl: inventoryBaseUrl,
    getPartSerialNosAndQuantityByWarehouse: (partNo: string, warehouseCode: string) => inventoryBaseUrl + `/GetSerialNumbers?warehouseCode=${encodeURIComponent(warehouseCode)}&partNumber=${encodeURIComponent(partNo)}`,
    setInventoryAvailability: inventoryBaseUrl + '/SetInventoryAvailability',
}

/**
 * banner apis.
 */
const bannerBaseUrl = apiUrl + 'Banner';
export const bannerApis = {
    baseUrl: bannerBaseUrl,
    getAll: bannerBaseUrl,
    create: bannerBaseUrl,
    update: bannerBaseUrl,
    remove: (bannerId: number) => bannerBaseUrl + `/${bannerId}`,
    addTag: (bannerId: number, tagId: number) => bannerBaseUrl + `/AddTag/${encodeURIComponent(bannerId)}/${encodeURIComponent(tagId)}`,
    removeTag: (bannerId: number, tagId: number) => bannerBaseUrl + `/RemoveTag/${encodeURIComponent(bannerId)}/${encodeURIComponent(tagId)}`,
}

/**
 * Homepage Edition apis.
 */
const homepageEditionBaseUrl = apiUrl + 'HomePageEdition';
export const homepageEditionApis = {
    baseUrl: homepageEditionBaseUrl,
    search: homepageEditionBaseUrl + '/list',
    create: homepageEditionBaseUrl,
    update: homepageEditionBaseUrl,
    getDetails: (editionId: number, tabId?: number) => homepageEditionBaseUrl + `?id=${editionId}${!!tabId ? `&tabId=${tabId}` : ''}`,
    remove: (editionId: number) => homepageEditionBaseUrl + `/${encodeURIComponent(editionId)}`,
    setAsLive: (editionId: number) => homepageEditionBaseUrl + `/SetLive/${encodeURIComponent(editionId)}`,
}

/**
 * Homepage Edition Tab apis.
 */
const homepageEditionTabBaseUrl = apiUrl + 'Tab';
export const homepageEditionTabApis = {
    baseUrl: homepageEditionTabBaseUrl,
    create: homepageEditionTabBaseUrl,
    update: homepageEditionTabBaseUrl,
    updateOrderIndex: homepageEditionTabBaseUrl + '/updateIndex',
    remove: (tabId: number) => homepageEditionTabBaseUrl + `/${encodeURIComponent(tabId)}`,
}

/**
 * Homepage Edition Tab Component apis.
 */
const homepageEditionTabComponentBaseUrl = apiUrl + 'TabComponent';
export const homepageEditionTabComponentApis = {
    baseUrl: homepageEditionTabComponentBaseUrl,
    updateGeneralInfo: homepageEditionTabComponentBaseUrl,
    create: homepageEditionTabComponentBaseUrl,
    update: homepageEditionTabComponentBaseUrl,
    updateOrderIndex: homepageEditionTabComponentBaseUrl + '/updateIndex',
    updateContent: homepageEditionTabComponentBaseUrl + '/updateContent',
    remove: (id: number) => homepageEditionTabComponentBaseUrl + `/${encodeURIComponent(id)}`,
}

const partCompareBaseUrl = apiUrl + 'partCompare';
export const partCompareApis = {
    baseUrl: partCompareBaseUrl,
    getCompareList: partCompareBaseUrl,
    addPart: partCompareBaseUrl,
    removePart: (partId: number) => partCompareBaseUrl + `?partId=${encodeURIComponent(partId)}`,
    removeCategory: (categoryId: number) => partCompareBaseUrl + `/DeleteCategory?categoryId=${encodeURIComponent(categoryId)}`,
}


/**
 * Elastic Apis
 */
const themeEditorBaseUrl = apiUrl + 'ThemeEditor';
export const themeEditorApis = {
    baseUrl: themeEditorBaseUrl,
    getEditToken: themeEditorBaseUrl + '/GetToken',
    validateToken: themeEditorBaseUrl + '/ValidateToken',
    update: themeEditorBaseUrl + '/Update',
}


/**
 * Online payment report apis.
 */
const onlinePaymentReportBaseUrl = apiUrl + 'OnlinePaymentReport';
export const onlinePaymentReportApis = {
    baseUrl: onlinePaymentReportBaseUrl,
    search: onlinePaymentReportBaseUrl + `/GetReport`,
    getTransactionTypes: onlinePaymentReportBaseUrl + '/GetTransactionTypes',
    getGeneralReport: onlinePaymentReportBaseUrl + `/GetGeneralReport`,
    searchTimeline: onlinePaymentReportBaseUrl + `/GetTimeLineReport`
}

/**
 * POS apis.
 */
const posBaseUrl = apiUrl + 'POS';
export const posApis = {
    baseUrl: posBaseUrl,
    makePayment: posBaseUrl + `/MakePayment`,
    getClientReceipt: (receiptId: number, customerId: number) => posBaseUrl + `/GetClientReceipt?receiptId=${receiptId}&customerId=${customerId}`,
    getMerchantReceipt: (receiptId: number, customerId: number) => posBaseUrl + `/GetMerchantReceipt?receiptId=${receiptId}&customerId=${customerId}`,
    emailClientReceipt: posBaseUrl + `/EmailClientReceipt`,
    emailMerchantReceipt: posBaseUrl + `/EmailMerchantReceipt`,
    getStoreInformation: posBaseUrl + `/GetStoreInformation`,
    saveStoreInformation: posBaseUrl + `/SaveStoreInformation`,
}

/**
 * Bulk Price Change Apis.
 */
const bulkPriceChangeBaseUrl = apiUrl + 'BulkPriceChange';
export const bulkPriceChangeApis = {
    baseUrl: bulkPriceChangeBaseUrl,
    create: bulkPriceChangeBaseUrl,
    partSelectionAutocomplete: (keywords: string) => bulkPriceChangeBaseUrl + `/PartSelectionAutoComplete?keyword=${encodeURIComponent(keywords?.trim())}`,
    addParts: bulkPriceChangeBaseUrl + '/AddParts',
    listParts: bulkPriceChangeBaseUrl + '/ListParts',
    updateStatus: bulkPriceChangeBaseUrl + '/UpdateStatus',
    savePriceLevels: bulkPriceChangeBaseUrl + '/SavePriceLevels',
    updatePriceChangeInfo: bulkPriceChangeBaseUrl + '/UpdatePriceChangeInfo',
    get: (id: number) => bulkPriceChangeBaseUrl + `/${id}`,
    changePrice: bulkPriceChangeBaseUrl + `/changePrice`,
    getLogs: bulkPriceChangeBaseUrl + `/getLogs`,
    newAttempt: bulkPriceChangeBaseUrl + `/NewAttempt`,
    cancel: bulkPriceChangeBaseUrl + `/Cancel`,
    getDashboard: bulkPriceChangeBaseUrl + `/GetDashboard`,
}

/**
 * Driver Checklist Apis.
 */
const partSupportDriverCheckListBaseUrl = apiUrl + 'DriverCheckList';
export const PartSupportDriverCheckListApis = {
    baseUrl: partSupportDriverCheckListBaseUrl,
    getCurrentDriverCheckList: (partSupportId: number) => partSupportDriverCheckListBaseUrl + `/Get/${partSupportId}`,
    updateCurrentDriverCheckList: partSupportDriverCheckListBaseUrl,
}

/**
 * New Part Support Request Apis.
 */
const newPartSupportRequestBaseUrl = apiUrl + 'NewPartSupportReq';
export const NewPartSupportReqApis = {
    baseUrl: newPartSupportRequestBaseUrl,
    updatePartSupportAdditionalInformation: newPartSupportRequestBaseUrl,
    generatePublicLink: newPartSupportRequestBaseUrl + '/GeneratePublicLink',
    updatePublicLink: newPartSupportRequestBaseUrl + '/UpdatePublicLink',
    reportPartSupportReq: newPartSupportRequestBaseUrl + '/ReportPartSupportReq',
    updateVendorStatus: newPartSupportRequestBaseUrl + '/UpdateVendorStatus',
    updateOperator: newPartSupportRequestBaseUrl + '/ReplaceOperator',
    rgaAutocomplete: (keyword) => newPartSupportRequestBaseUrl + `/AutoComplete?keyword=${encodeURIComponent(keyword ?? "")}`
}


/**
 * Drivers Apis.
 */
const driverBaseUrl = apiUrl + 'Driver';
export const DriverApis = {
    baseUrl: driverBaseUrl,
    createNewDriver: driverBaseUrl,
    getListOfDrivers: driverBaseUrl + '/List',
    bulkRemoveDrivers: driverBaseUrl,
    updateDriver: driverBaseUrl
}

/**
 * New Account receivable apis
 */
const newARBaseUrl = apiUrl + 'Ar';
export const NewARApis = {
    baseUrl: newARBaseUrl,
    getARAgedList: newARBaseUrl + '/ArAgedList',
    listArTransactions: newARBaseUrl + '/ListArTransactions',
    connectArTransactions: newARBaseUrl + '/ConnectArTransactions',
}

/**
 * Api Adjustment reasons apis
 */
const inventoryAdjustmentReasonBaseUrl = apiUrl + 'InventoryAdjustmentReason';
export const InventoryAdjustmentReasonsApis = {
    baseUrl: inventoryAdjustmentReasonBaseUrl,
    createReason: inventoryAdjustmentReasonBaseUrl + '/CreateReason',
    getReasonList: inventoryAdjustmentReasonBaseUrl + '/ListReasons',
    updateReason: inventoryAdjustmentReasonBaseUrl + '/UpdateReason',
    removeReason: (id: number) => inventoryAdjustmentReasonBaseUrl + `/${encodeURIComponent(id)}`,
}

/**
 * Inventory adjustment apis
 */
const inventoryAdjustmentBaseUrl = apiUrl + 'InventoryAdjustment';
export const inventoryAdjustmentApis = {
    baseUrl: inventoryAdjustmentBaseUrl,
    getAvailableSerialNumbers: inventoryAdjustmentBaseUrl + '/GetAvailableSerialNumbers',
    createAdjustment: inventoryAdjustmentBaseUrl + '/CreateAdjustment',
    getAdjustmentsList: inventoryAdjustmentBaseUrl + '/ListAdjustments',
    getAdjustmentsItems: inventoryAdjustmentBaseUrl + '/ListAdjustmentItems',
    getAdjustmentReport: inventoryAdjustmentBaseUrl + '/GetAdjustmentReport',
    getAdjustment: (id: number) => inventoryAdjustmentBaseUrl + `/GetAdjustment/${id}`,
}

const regionsBaseUrl = apiUrl + 'Region';
export const regionsApis = {
    baseUrl: regionsBaseUrl,
    get: regionsBaseUrl + '/List',
    create: regionsBaseUrl,
    update: regionsBaseUrl,
    delete: regionsBaseUrl + '/Delete',
    getCustomerRegion: regionsBaseUrl + '/GetCustomerRegion',
}


const freightInfoBaseUrl = apiUrl + 'FreightInfo';
export const freightInfoApis = {
    baseUrl: freightInfoBaseUrl,
    saveOrder: freightInfoBaseUrl + '/SaveOrderFreight',
    saveInvoice: freightInfoBaseUrl + '/SaveInvoiceFreight',
    calculateFreeFreightEligibility: freightInfoBaseUrl + '/FreeFreightEligibility',
    estimateShippingFee: freightInfoBaseUrl + '/EstimateShippingFee',
}


const freightServiceBaseUrl = apiUrl + 'FreightApi/';

const freightCompaniesBaseUrl = freightServiceBaseUrl + 'FreightCompany';
export const freightCompaniesApis = {
    baseUrl: freightCompaniesBaseUrl,
    get: freightCompaniesBaseUrl + '/List',
    create: freightCompaniesBaseUrl,
    update: freightCompaniesBaseUrl,
    delete: freightCompaniesBaseUrl + '/Delete',
}


const freightOrderBaseUrl = freightServiceBaseUrl + 'Order';
export const freightOrderApis = {
    baseUrl: freightOrderBaseUrl,
    getOrder: (salesOrderId?: number, invoiceId?: number) => freightOrderBaseUrl + `/GetOrder?${salesOrderId ? `salesOrderId=${salesOrderId}` : ''}${salesOrderId && invoiceId ? "&" : ""}${invoiceId ? `invoiceId=${invoiceId}` : ''}`,
    listOrders: freightOrderBaseUrl + '/ListOrders',
    updateOrder: freightOrderBaseUrl + '/UpdateOrder',
    getOrderReport: freightOrderBaseUrl + '/GetOrderReport',
}

const freightQuoteBaseUrl = freightServiceBaseUrl + 'Quote';
export const freightQuoteApis = {
    baseUrl: freightQuoteBaseUrl,
    saveQuoteProvider: freightQuoteBaseUrl + '/SaveQuoteProvider',
    getQuoteProvider: freightQuoteBaseUrl + '/GetQuoteProvider',
}

const freightCategoryExceptionBaseUrl = freightServiceBaseUrl + 'CategoryException';
export const freightCategoryExceptionApis = {
    baseUrl: freightCategoryExceptionBaseUrl,
    list: freightCategoryExceptionBaseUrl + '/ListCategoryExceptions',
    save: freightCategoryExceptionBaseUrl + '/SaveCategoryException',
    remove: freightCategoryExceptionBaseUrl + '/RemoveCategoryException',
}


const freightFlatExceptionBaseUrl = freightServiceBaseUrl + 'FlatException';
export const freightFlatExceptionApis = {
    baseUrl: freightFlatExceptionBaseUrl,
    list: (customerId?: number) => freightFlatExceptionBaseUrl + `/ListFlatExceptions${customerId ? `?originalCustomerId=${customerId}` : ''}`,
    save: freightFlatExceptionBaseUrl + '/CreateFlatException',
}

const freightPartExceptionBaseUrl = freightServiceBaseUrl + 'PartException';
export const freightPartExceptionApis = {
    baseUrl: freightPartExceptionBaseUrl,
    list: freightPartExceptionBaseUrl + `/ListPartExceptions`,
    save: freightPartExceptionBaseUrl + '/AddPartException',
    remove: freightPartExceptionBaseUrl + '/RemovePartException',
}


const freightPriceLevelExceptionBaseUrl = freightServiceBaseUrl + 'PriceLevelException';
export const freightPriceLevelExceptionApis = {
    baseUrl: freightPriceLevelExceptionBaseUrl,
    list: freightPriceLevelExceptionBaseUrl + '/ListPriceLevelExceptions',
    save: freightPriceLevelExceptionBaseUrl + '/SavePriceLevelException',
    remove: freightPriceLevelExceptionBaseUrl + '/RemovePriceLevelException',
}

const freightRegionExceptionBaseUrl = freightServiceBaseUrl + 'RegionException';
export const freightRegionExceptionApis = {
    baseUrl: freightRegionExceptionBaseUrl,
    list: freightRegionExceptionBaseUrl + '/ListRegionExceptions',
    save: freightRegionExceptionBaseUrl + '/SaveRegionException',
    remove: freightRegionExceptionBaseUrl + '/RemoveRegionException',
}

const freightCompanyExceptionBaseUrl = freightServiceBaseUrl + 'FreightCompanyException';
export const freightCompanyExceptionApis = {
    baseUrl: freightCompanyExceptionBaseUrl,
    list: freightCompanyExceptionBaseUrl + '/ListFreightCompanyExceptions',
    save: freightCompanyExceptionBaseUrl + '/SaveFreightCompanyExceptions',
    remove: freightCompanyExceptionBaseUrl + '/RemoveFreightCompanyExceptions',
}


const freightCustomerExceptionBaseUrl = freightServiceBaseUrl + 'CustomerException';
export const freightCustomerExceptionApis = {
    baseUrl: freightCustomerExceptionBaseUrl,
    list: freightCustomerExceptionBaseUrl + '/ListCustomerException',
    get: (customerId: number) => freightCustomerExceptionBaseUrl + `/GetCustomerException/${customerId}`,
    add: freightCustomerExceptionBaseUrl + '/AddCustomerException',
    delete: (customerExceptionId: number) => freightCustomerExceptionBaseUrl + `/DeleteCustomerException/${customerExceptionId}`,
}

const freeFreightRequestBaseUrl = freightServiceBaseUrl + 'FreeFreightRequest';
export const freeFreightRequestApis = {
    baseUrl: freeFreightRequestBaseUrl,
    getFreeFreightEligibility: (id: number) => freeFreightRequestBaseUrl + `/GetFreeFreight/${id}`,
    simulateFreeFreight: freeFreightRequestBaseUrl + '/SimulateFreeFreight',
}

const regionRateBaseUrl = freightServiceBaseUrl + 'RegionRate';
export const regionRateApis = {
    baseUrl: regionRateBaseUrl,
    list: regionRateBaseUrl + '/ListRegionRates',
    save: regionRateBaseUrl + '/SaveRegionRate',
    remove: regionRateBaseUrl + '/RemoveRegionRate',
}

const partRateBaseUrl = freightServiceBaseUrl + 'PartRate';
export const freightPartRateApis = {
    baseUrl: partRateBaseUrl,
    list: partRateBaseUrl + '/ListPartRates',
    save: partRateBaseUrl + '/SavePartRate',
    remove: partRateBaseUrl + '/RemovePartRate',
}


const newPriceMatrixBaseUrl = apiUrl + 'CleanAF/NewPriceMatrix';
export const newPriceMatrixApis = {
    baseUrl: newPriceMatrixBaseUrl,
    exceptionalCustomersList: newPriceMatrixBaseUrl + '/GetExceptionalList',
}


const bizPrintServiceBaseUrl = apiUrl + 'BizPrint';
export const bizPrintTemplateAccessBaseUrl = bizPrintServiceBaseUrl + '/TemplateAccess';

export const bizPrintTemplateAccessApis = {
    baseUrl: bizPrintTemplateAccessBaseUrl,
    GenerateToken: bizPrintTemplateAccessBaseUrl + '/GenerateToken',
}

const bizPrintTemplateBaseUrl = bizPrintServiceBaseUrl + '/Template';

export const bizPrintTemplateApis = {
    baseUrl: bizPrintTemplateBaseUrl,
    listTemplate: (pageName: string, applicationId: string) => bizPrintTemplateBaseUrl + '/ListTemplate?pageName=' + pageName + '&applicationId=' + applicationId,
    removeTemplate: (templateId: number, applicationId: string) => bizPrintTemplateBaseUrl + '/RemoveTemplate?id=' + templateId + '&applicationId=' + applicationId,
    duplicateTemplate: bizPrintTemplateBaseUrl + '/DuplicateTemplate',
}


/**
 * Catalogue apis
 */
export const catalogueBaseUrl = apiUrl + 'CleanAF/Catalogue';
export const catalogueApis = {
    baseUrl: catalogueBaseUrl,
    getProducts: catalogueBaseUrl + '/GetProducts',
}


const partnerPrinterHubBaseUrl = virtualPrinterUrl + 'PartnerPrinterHub';
export const partnerPrinterHubApis = {
    baseUrl: partnerPrinterHubBaseUrl,
    list: partnerPrinterHubBaseUrl + '/List',
    update: partnerPrinterHubBaseUrl + '/UpdateConnection',
}


const printerHubBaseurl = virtualPrinterUrl + 'PrinterHub';
export const printerHubApis = {
    baseUrl: printerHubBaseurl,
    connect: printerHubBaseurl + '/Connect',
    disconnect: (id: number) => printerHubBaseurl + `/Disconnect?partnerHubId=${id}`,
    getApplicationInfo: printerHubBaseurl + '/GetLinkAndCreateCode',
}

const printerHubQueueBaseUrl = virtualPrinterUrl + 'Queue';
export const printerHubQueueApis = {
    baseUrl: printerHubQueueBaseUrl,
    list: printerHubQueueBaseUrl + '/List',
    create: printerHubQueueBaseUrl,
    checkStatus: printerHubQueueBaseUrl + '/HaveDone',
    copy: printerHubQueueBaseUrl + '/Copy',

}

const tasksBaseUrl = tasksApiUrl + 'Tasks';
export const tasksApis = {
    baseUrl: tasksBaseUrl,
    getTodayTaskSummary: tasksBaseUrl + '/GetTodaysTaskSummary',
    getMyTasks: tasksBaseUrl + '/GetMyTasks',
    getAssignedTasks: tasksBaseUrl + '/GetAssignedTasks',
    createTask: tasksBaseUrl + '/CreateTask',
    updateTask: tasksBaseUrl + '/UpdateTask',
    changeTaskStatus: tasksBaseUrl + '/ChangeTaskStatus',
    removeTask: (taskId: number) => tasksBaseUrl + `/RemoveTask?taskId=${taskId}`,
    listByTags: tasksBaseUrl + '/GetTasksByTags',
}

const taskStatusBaseUrl = tasksApiUrl + 'TaskStatus';
export const taskStatusApis = {
    baseUrl: taskStatusBaseUrl,
    getTaskStatuses: taskStatusBaseUrl + '/GetTaskStatuses',
    create: taskStatusBaseUrl + '/Create',
    update: taskStatusBaseUrl + '/Update',
    reorder: taskStatusBaseUrl + '/Reorder',
    remove: (id: number) => taskStatusBaseUrl + `/Remove?taskStatusId=${id}`,
}

export const reportingToolsApis = {
    get: (pageName: string) => apiUrl + `CleanAF/ReportingTools/GetColumns?reportName=${encodeURIComponent(pageName)}`,
    getNotes: (pageName: string) => notesApiUrl + `ReportingTools/GetColumns?reportName=${encodeURIComponent(pageName)}`,
    geTasks: (pageName: string) => tasksApiUrl + `ReportingTools/GetColumns?reportName=${encodeURIComponent(pageName)}`,
    getNcr: (pageName: string) => ncrApiUrl + `ReportingTools/GetColumns?reportName=${encodeURIComponent(pageName)}`,
}


const newInvoicesBaseUrl = apiUrl + 'CleanAF/Invoice';
export const newInvoicesApis = {
    baseUrl: newInvoicesBaseUrl,
    getInvoicesForPart: newInvoicesBaseUrl + '/ListByPartNumber',
}


const partSupportReqVendorStatusBaseUrl = apiUrl + 'CleanAF/PartSupportReqVendorStatus';
export const partSupportReqVendorStatusApis = {
    baseUrl: partSupportReqVendorStatusBaseUrl,
    list: partSupportReqVendorStatusBaseUrl,
    create: partSupportReqVendorStatusBaseUrl,
    update: partSupportReqVendorStatusBaseUrl,
    remove: (id: number, replacementId: number) => partSupportReqVendorStatusBaseUrl + `?id=${id}&replacementId=${replacementId}`,
}

const notesBaseUrl = notesApiUrl + 'Note';
export const notesApis = {
    baseUrl: notesBaseUrl,
    listByTags: notesBaseUrl + '/ListByTags',
    createNote: notesBaseUrl,
    updateNote: notesBaseUrl,
    removeNote: (noteId: number) => notesBaseUrl + `?id=${noteId}`,
}

const uiComponentBaseUrl = apiUrl + 'UiComponent';
export const uiComponentApis = {
    baseUrl: uiComponentBaseUrl,
    get: uiComponentBaseUrl + `/GetApplicationComponents`,
    save: uiComponentBaseUrl + `/Save`,
}


const ncrBaseUrl = ncrApiUrl;

const ncrReportsBaseUrl = ncrBaseUrl + 'Report';
export const ncrReportsApis = {
    initiateReport: ncrReportsBaseUrl + '/InitiateReport',
    assignParts: ncrReportsBaseUrl + '/AssignParts',
    assignProcess: ncrReportsBaseUrl + '/AssignProcess',
    checkCodeDuplication: (code: string) => ncrReportsBaseUrl + `/CheckCodeDuplication/${code}`,
    listReports: ncrReportsBaseUrl + '/ListReports',
    updateReport: ncrReportsBaseUrl + '/UpdateReport',
    changeReportStatus: ncrReportsBaseUrl + '/ChangeReportStatus',
    getReport: (id: number) => ncrReportsBaseUrl + `/GetReport/${id}`,
    removeReport: (id: number) => ncrReportsBaseUrl + `/RemoveReport/${id}`,
}

const ncrStatusBaseUrl = ncrBaseUrl + 'Status';
export const ncrStatusApis = {
    getInitialStatus: ncrStatusBaseUrl + '/GetInitialStatus',
    list: ncrStatusBaseUrl + '/ListStatus',
    create: ncrStatusBaseUrl + '/CreateStatus',
    update: ncrStatusBaseUrl + '/UpdateStatus',
    changeStatusIndexes: ncrStatusBaseUrl + '/ChangeStatusIndexes',
    getRelatedReportNo: (id: number) => ncrStatusBaseUrl + `/GetRelatedReportNo/${id}`,
    delete: (id: number, replaceId: number) => ncrStatusBaseUrl + `/DeleteStatus?id=${id}&replacementId=${replaceId}`,
}

const ncrSettingBaseUrl = ncrBaseUrl + 'Setting';
export const ncrSettingApis = {
    getPartnerSettings: ncrSettingBaseUrl + '/GetPartnerSettings',
    updatePartnerSettings: ncrSettingBaseUrl + '/UpdatePartnerSetting',
    resetToDefaultPartnerSettings: ncrSettingBaseUrl + '/ResetToDefaultPartnerSetting',
}

const ncrNoteTitleSuggestionsBaseUrl = ncrBaseUrl + 'NoteTitleSuggestion';
export const ncrNoteTitleSuggestionsApis = {
    list: ncrNoteTitleSuggestionsBaseUrl + '/ListNTS',
    create: ncrNoteTitleSuggestionsBaseUrl + '/CreateNTS',
    update: ncrNoteTitleSuggestionsBaseUrl + '/UpdateNTS',
    delete: (id: number) => ncrNoteTitleSuggestionsBaseUrl + `/DeleteNTS/${id}`,
}

const ncrProcessBaseUrl = ncrBaseUrl + 'Process';
export const ncrProcessApis = {
    listProcesses: ncrProcessBaseUrl + '/ListProcess',
    create: ncrProcessBaseUrl + '/CreateProcess',
    update: ncrProcessBaseUrl + '/UpdateProcess',
    delete: (id: number) => ncrProcessBaseUrl + `/DeleteProcess/${id}`,
}

const ncrActionGroupsBaseUrl = ncrBaseUrl + 'ActionGroup';
export const ncrActionGroupsApis = {
    list: ncrActionGroupsBaseUrl + '/ListActionGroups',
    create: ncrActionGroupsBaseUrl + '/CreateActionGroup',
    update: ncrActionGroupsBaseUrl + '/UpdateGroupAction',
    changeStatusIndexes: ncrActionGroupsBaseUrl + '/ChangeStatusIndexes',
}


const bizFileBaseUrl = apiUrl + 'CleanAF/BizFile';
export const bizFileApis = {
    uploadRemainingChunk: bizFileBaseUrl + '/UploadRemainingChunk',
    createAccessToken: bizFileBaseUrl + '/CreateAccessToken',
    uploadFile: bizFileBaseUrl + '/SmallFileOrInitiateUpload',
    getStorageAccount: bizFileBaseUrl + '/GetStorageAccount',
    createStorageAccount: bizFileBaseUrl + '/CreateStorageAccount',
    deleteFile: (fileId: number) => bizFileBaseUrl + `/${fileId}`,
}

const SalesTaxBaseUrl = apiUrl + 'CleanAF/SalesTax';
export const salesTaxApis = {
    baseUrl: SalesTaxBaseUrl,
    createSalesTax: SalesTaxBaseUrl + '/CreateSalesTax',
    updateSalesTax: SalesTaxBaseUrl + '/UpdateSalesTax',
    salesTaxList: SalesTaxBaseUrl + '/SalesTaxList',
    addTaxToProvince: SalesTaxBaseUrl + '/AddTaxToProvince',
    updateProvinceTax: SalesTaxBaseUrl + '/UpdateProvinceTax',
    removeProvinceTax: (id: number) => SalesTaxBaseUrl + `/RemoveProvinceTax/${id}`,
    provinceTaxList: (countryId: number) => SalesTaxBaseUrl + `/ProvinceTaxList/${countryId}`,
}

const industryBaseUrl = apiUrl + 'CleanAF/Industry';
export const industryApis = {
    baseUrl: industryBaseUrl,
    getAllIndustries: industryBaseUrl + '/ListAllIndustries',
    accessToIndustry: industryBaseUrl + '/AccessToIndustry',
    listPartnerIndustries: industryBaseUrl + '/ListPartnerIndustries',
    setDefaultIndustry: industryBaseUrl + '/SetDefaultIndustry',
}

const newPartCategoryBaseUrl = apiUrl + 'CleanAF/PartCategory';
export const newPartCategoryApis = {
    baseUrl: newPartCategoryBaseUrl,
    getAllPartCategories: (industryId: number) => newPartCategoryBaseUrl + `/GetAllPartCategories/${encodeURIComponent(industryId)}`,
    createPartCategory: newPartCategoryBaseUrl + '/CreatePartCategory',
    updatePartCategory: newPartCategoryBaseUrl + '/UpdatePartCategory',
    selectPartCategory: newPartCategoryBaseUrl + '/SelectPartCategory',
    unSelectPartCategory: newPartCategoryBaseUrl + '/UnSelectPartCategory',
    removePartCategory: newPartCategoryBaseUrl + `/RemovePartCategory`,
    listPartCategory: (industryId: number) => newPartCategoryBaseUrl + `/ListPartCategory/${encodeURIComponent(industryId)}`,
    getIndustryIds: newPartCategoryBaseUrl + '/GetIndustryId',
}

const industryPropertyBaseUrl = apiUrl + 'CleanAF/IndustryProperty';
export const industryPropertyApis = {
    createCustomProperty: industryPropertyBaseUrl + '/CreateCustomProperty',
    updateCustomProperty: industryPropertyBaseUrl + '/UpdateCustomProperty',
    removeCustomProperty: (id: number) => industryPropertyBaseUrl + `/RemoveCustomProperty/${id}`,
    relatedPartsCount: (id: number) => industryPropertyBaseUrl + `/RelatedPartsCount/${id}`,
    setConfig: industryPropertyBaseUrl + '/SetConfig',
    getEligibleProperties: industryPropertyBaseUrl + '/GetEligibleProperties',
    addPropertyValue: industryPropertyBaseUrl + '/AddPropertyValue',
    updatePropertyValue: industryPropertyBaseUrl + '/UpdatePropertyValue',
    deletePropertyValue: industryPropertyBaseUrl + `/DeletePropertyValue`,
    listPropertyValues: (propertyId: number) => industryPropertyBaseUrl + `/ListPropertyValues/${propertyId}`,
    autoSuggest: industryPropertyBaseUrl + `/AutoSuggest`,
    suggestProperty: industryPropertyBaseUrl + `/SuggestProperty`,
    getExtraConfigs: (industryId: string) => industryPropertyBaseUrl + `/GetExtraConfigs?industryId=${encodeURIComponent(industryId)}`,
    saveExtraConfigs: industryPropertyBaseUrl + `/SaveExtraConfigs`,
    list: (industryId: string) => industryPropertyBaseUrl + `/List?industryId=${encodeURIComponent(industryId)}`,
}

const industryPropertyTemplateBaseUrl = apiUrl + 'CleanAF/IndustryPropertyTemplate';
export const industryPropertyTemplateApis = {
    delete: (id: number) => industryPropertyTemplateBaseUrl + `/${id}`,
    get: (id: number) => industryPropertyTemplateBaseUrl + `/${id}`,
    setProperties: industryPropertyTemplateBaseUrl + '/SetProperties',
    list: (industryId: number) => industryPropertyTemplateBaseUrl + `/List/${industryId}`,
    create: industryPropertyTemplateBaseUrl,
    update: industryPropertyTemplateBaseUrl,
}

const partIndustryPropertyBaseUrl = apiUrl + 'CleanAF/PartIndustryProperty';
export const partIndustryPropertyApis = {
    addProperties: partIndustryPropertyBaseUrl + '/AddProperties',
    addProperty: partIndustryPropertyBaseUrl + '/AddProperty',
    clearProperty: (industryPropertyId: number, partId: number) => partIndustryPropertyBaseUrl + `/ClearProperty?industryPropertyId=${industryPropertyId}&partId=${partId}`,
    removeProperty: (partIndustryPropertyId: number) => partIndustryPropertyBaseUrl + `/RemoveProperty?partIndustryPropertyId=${partIndustryPropertyId}`,
    setPropertyValue: partIndustryPropertyBaseUrl + '/SetPropertyValue',
    setPropertyValues: partIndustryPropertyBaseUrl + '/SetPropertyValues',
    list: (partId: number) => partIndustryPropertyBaseUrl + `/${partId}`,
}


const industryGroupPropertyBaseUrl = apiUrl + 'CleanAF/IndustryGroupProperty';
export const industryGroupPropertyApis = {
    query: industryGroupPropertyBaseUrl + '/Query',
    list: (industryId: number) => industryGroupPropertyBaseUrl + `/List/${industryId}`,
    listAttrs: (industryGroupPropertyId: number) => industryGroupPropertyBaseUrl + `/ListAttrs/${industryGroupPropertyId}`,
    insert: industryGroupPropertyBaseUrl + '/Insert',
}

const nexusSearchBaseUrl = apiUrl + 'CleanAF/NexusSearch';
export const nexusSearchApis = {
    getBaseStructure: (industryId: string) => nexusSearchBaseUrl + `/GetBaseStructure?industryId=${industryId}`,
    getSuggestion: nexusSearchBaseUrl + '/GetSuggestion',
    search: nexusSearchBaseUrl + '/Search',
    partInformationSearch: nexusSearchBaseUrl + '/PartInformationSearch',
    submitClick: nexusSearchBaseUrl + '/SubmitClick',
    getSearchLog: (searchToken: string) => nexusSearchBaseUrl + `/GetSearchLog?searchToken=${searchToken}`,
    submitLostSearch: nexusSearchBaseUrl + '/SubmitLostSearch',
    getConfig: nexusSearchBaseUrl + '/GetConfig',
    saveConfig: nexusSearchBaseUrl + '/SaveConfig',
    connectToCustomer: nexusSearchBaseUrl + '/ConnectCustomerToSearchLog',
    connectToOrder: nexusSearchBaseUrl + '/ConnectOrderToSearchLog'
}

const partCodeCategoryBaseUrl = apiUrl + 'CleanAF/PartCodeCategory';
export const partCodeCategoryApis = {
    delete: (id: number) => partCodeCategoryBaseUrl + `/${id}`,
    reActivate: partCodeCategoryBaseUrl + `/ReActivate`,
    create: partCodeCategoryBaseUrl,
    update: partCodeCategoryBaseUrl,
    list: partCodeCategoryBaseUrl,
}

const partCodeValueBaseUrl = apiUrl + 'CleanAF/PartCodeValue';
export const partCodeValueApis = {
    delete: (id: number) => partCodeValueBaseUrl + `/${id}`,
    editViewList: (partId: number) => partCodeValueBaseUrl + `/EditViewList/${partId}`,
    partInfoList: (partId: number) => partCodeValueBaseUrl + `/PartInfoList/${partId}`,
    create: partCodeValueBaseUrl,
    update: partCodeValueBaseUrl,
}


const partGroupIndustryPropertyBaseUrl = apiUrl + 'CleanAF/PartGroupIndustryProperty';
export const partGroupIndustryPropertyApis = {
    addGroupProperty: partGroupIndustryPropertyBaseUrl + '/AddGroupProperty',
    delete: (id: number) => partGroupIndustryPropertyBaseUrl + `/${id}`,
    list: (industryGroupPropertyId: number, partId: number) => partGroupIndustryPropertyBaseUrl + `/List/${industryGroupPropertyId}/${partId}`,
}

const PartnerConnectionBaseUrl = apiUrl + 'CleanAF/PartnerConnection';
export const PartnerConnectionApis = {
    sendSellerRequest: PartnerConnectionBaseUrl + '/SendSellerRequest',
    sellersList: PartnerConnectionBaseUrl + '/SellersList',
    buyersList: PartnerConnectionBaseUrl + '/BuyersList',
    acceptSellerRequest: PartnerConnectionBaseUrl + '/AcceptSellerRequest',
    replaceVendor: PartnerConnectionBaseUrl + '/ReplaceVendor',
    replaceCustomer: PartnerConnectionBaseUrl + '/ReplaceCustomer',
    updateSellerConfig: PartnerConnectionBaseUrl + '/UpdateSellerConfig',
    getPartnersAndWarehouses: PartnerConnectionBaseUrl + '/GetPartnersAndWarehouses',
}

const priceLevelBaseUrl = apiUrl + 'CleanAF/PriceLevel';
export const priceLevelApis = {
    listTitleDictionary: priceLevelBaseUrl + '/ListTitleDictionary',
    saveTitleDictionary: priceLevelBaseUrl + '/SaveTitleDictionary',
}

const adminApisBaseUrl = apiUrl + 'CleanAF/Admin';
export const adminApis = {
    getParts: adminApisBaseUrl + '/GetParts',
}

const orderV2BaseUrl = apiUrl + 'CleanAF/Order';
export const orderV2Apis = {
    create: orderV2BaseUrl,
}

const customerV2baseUrl = apiUrl + 'CleanAF/Customer';
export const customerV2Apis = {
    autoComplete: (keyword?: string) => customerV2baseUrl + `/AutoComplete?keyword=${encodeURIComponent(keyword ?? "")}`,
    search: customerV2baseUrl + '/Search',
    simpleGetById: (id: number) => customerV2baseUrl + `/SimpleGet?id=${id}`,
    simpleGetByCode: (code: string) => customerV2baseUrl + `/SimpleGet?code=${encodeURIComponent(code)}`,
    getPriceLevels: (customerId: number) => customerV2baseUrl + `/GetPriceLevels?customerId=${customerId}`,
    getFullInfo: (id: number) => customerV2baseUrl + `/GetFullInfo?id=${id}`,
    create: customerV2baseUrl + '/Create',
    updateCustomerOwner: customerV2baseUrl + '/UpdateCustomerOwner',
    removeCustomer: (id: number) => customerV2baseUrl + `?customerId=${id}`,
    listAccountManagersAndTerritories: customerV2baseUrl + '/ListAccountManagersAndTerritories',
    importUpdateCustomerOwner: customerV2baseUrl + '/ImportUpdateCustomerOwner',
    externalCustomerAutoFill: customerV2baseUrl + `/ExternalCustomerAutoFill`,
    importCustomerFromExternal: customerV2baseUrl + `/ImportCustomerFromExternal`,
    getAddresses: (customerId: number) => customerV2baseUrl + `/GetAddresses?customerId=${customerId}`,
    updateAddress: customerV2baseUrl + `/UpdateAddress`,
    setDefaultAddress: customerV2baseUrl + `/SetDefaultAddress`,
    updateAddressTax: customerV2baseUrl + `/UpdateAddressTax`,
    createAddress: customerV2baseUrl + `/CreateAddress`,
    deleteAddress: (customerId: number, addressId: number) => customerV2baseUrl + `/DeleteAddress?customerId=${customerId}&addressId=${addressId}`,
    removeUsers: customerV2baseUrl + `/RemoveUsers`,
}

/**
 * CleanAF Vendor CRM Apis (Spire-backed local vendor cache).
 */
const vendorV2BaseUrl = apiUrl + 'CleanAF/Vendor';
export const vendorV2Apis = {
    list: vendorV2BaseUrl + '/List',
    get: (id: number) => vendorV2BaseUrl + `/Get?id=${id}`,
    create: vendorV2BaseUrl + '/Create',
    import: vendorV2BaseUrl + '/Import',
    update: vendorV2BaseUrl + '/Update',
    changeStatus: vendorV2BaseUrl + '/ChangeStatus',
    deactivate: (id: number) => vendorV2BaseUrl + `/Deactivate?id=${id}`,
    addresses: (vendorId: number) => vendorV2BaseUrl + `/Addresses?vendorId=${vendorId}`,
    addAddress: vendorV2BaseUrl + '/AddAddress',
    addBillingAddress: vendorV2BaseUrl + '/AddBillingAddress',
    updateAddress: vendorV2BaseUrl + '/UpdateAddress',
    deleteAddress: (id: number) => vendorV2BaseUrl + `/DeleteAddress?id=${id}`,
    setDefaultShipping: vendorV2BaseUrl + '/SetDefaultShipping',
    accountSummary: (vendorId: number) => vendorV2BaseUrl + `/AccountSummary?vendorId=${vendorId}`,
    listStatuses: vendorV2BaseUrl + '/ListStatuses',
    addStatus: vendorV2BaseUrl + '/AddStatus',
    updateStatus: vendorV2BaseUrl + '/UpdateStatus',
    deleteStatus: (id: number, replacementId: number) => vendorV2BaseUrl + `/DeleteStatus?id=${id}&replacementId=${replacementId}`,
    setDefaultStatus: vendorV2BaseUrl + '/SetDefaultStatus',
    listUsers: vendorV2BaseUrl + '/ListUsers',
    addUser: vendorV2BaseUrl + '/AddUser',
    updateUser: vendorV2BaseUrl + '/UpdateUser',
    deleteUser: (id: number) => vendorV2BaseUrl + `/DeleteUser?id=${id}`,
}

/**
 * New Customer Credit Cards Apis
 */
const customerCreditCardsBaseUrl = apiUrl + 'CustomerCard';
export const customerCreditCardsApis = {
    baseUrl: customerCreditCardsBaseUrl,
    getCustomerCreditCards: (customerId: number) => customerCreditCardsBaseUrl + `?customerId=${customerId}`,
    addNewCustomerCreditCard: customerCreditCardsBaseUrl,
    removeCustomerCreditCard: (cardId: number, customerId: number) => customerCreditCardsBaseUrl + `?cardId=${cardId}&customerId=${customerId}`,
    setCustomerCreditCardAsDefault: (cardId: number, customerId: number) => customerCreditCardsBaseUrl + `/SetDefault?cardId=${cardId}&customerId=${customerId}`,
    getTransactionHistory: customerCreditCardsBaseUrl + `/GetTransactionHistory`,
    addCardByToken: customerCreditCardsBaseUrl + `/AddCardByToken`,
    getPaymentProviders: customerCreditCardsBaseUrl + `/GetPaymentProviders`,
    getStripePublicKey: customerCreditCardsBaseUrl + `/GetStripePublicKey`,
}

/**
 * The nexus search report apis.
 */
const nexusSearchReportBaseUrl = apiUrl + 'CleanAF/NexusSearchReport';
export const nexusSearchReportApis = {
    getNexusGeneralChart: nexusSearchReportBaseUrl + '/GetNexusGeneralChart',
    getTopQueries: nexusSearchReportBaseUrl + '/GetTopQueries',
    getTopQueriesWithResult: nexusSearchReportBaseUrl + '/GetTopQueriesWithResult',
    getTopQueriesLead2Click: nexusSearchReportBaseUrl + '/GetTopQueriesLead2Click',
    getTopQueriesWithoutResult: nexusSearchReportBaseUrl + '/GetTopQueriesWithoutResult',
    getTopClickedProducts: nexusSearchReportBaseUrl + '/GetTopClickedProducts',
    getTopCustomerHighSearch: nexusSearchReportBaseUrl + '/GetTopCustomerHighSearch',
    getTopCustomerHighClick: nexusSearchReportBaseUrl + '/GetTopCustomerHighClick',
    getTopCustomerHighQCRatio: nexusSearchReportBaseUrl + '/GetTopCustomerHighQCRatio',
    getTopOperatorsHighSearch: nexusSearchReportBaseUrl + '/GetTopOperatorsHighSearch',
    getTopOperatorsHighQCRatio: nexusSearchReportBaseUrl + '/GetTopOperatorsHighQCRatio',
    getNexusLogs: nexusSearchReportBaseUrl + '/GetNexusLogs',
    toggleNexusLogReview: nexusSearchReportBaseUrl + '/ToggleNexusLogReview',
    updateNexusLogReviewNote: nexusSearchReportBaseUrl + '/UpdateNexusLogReviewNote',
}

/**
 * Lost Sales APIs
 */
const lostSalesBaseUrl = apiUrl + 'CleanAF/LostSales';
export const lostSalesApis = {
    baseUrl: lostSalesBaseUrl,
    getTopReportedProductsByQty: lostSalesBaseUrl + '/GetTopReportedProductsByQty',
    getTopReportedProductsByValue: lostSalesBaseUrl + '/GetTopReportedProductsByValue',
    getTopReportedCustomersByQty: lostSalesBaseUrl + '/GetTopReportedCustomersByQty',
    getTopReportedCustomersByValue: lostSalesBaseUrl + '/GetTopReportedCustomersByValue',
    getTopReportedOperatorsByRequest: lostSalesBaseUrl + '/GetTopReportedOperatorsByRequest',
    getLostSalesChart: lostSalesBaseUrl + '/GetLostSalesChart',
    listReportedLostSales: lostSalesBaseUrl + '/ListReportedLostSales',
    toggleReportLostSaleCheck: lostSalesBaseUrl + '/ToggleReportLostSaleCheck'
}


/**
 * Export Apis
 */
const exportBaseUrl = apiUrl + 'CleanAF/Export';
export const exportApis = {
    baseUrl: exportBaseUrl,
    exportSalesTax: exportBaseUrl + '/ExportSalesTax',
}

const customDashboardBaseUrl = apiUrl + 'CleanAF/CustomDashboard';
export const customDashboardApis = {
    baseUrl: customDashboardBaseUrl,
    loadWidgetData: customDashboardBaseUrl + '/LoadWidgetData',
    deleteDashboard: (dashboardId: number) => customDashboardBaseUrl + `/${dashboardId}`,
    allWidgets: customDashboardBaseUrl + '/AllWidgets',
    setDefaultDashboard: customDashboardBaseUrl + '/SetDefaultDashboard',
    updateUIData: customDashboardBaseUrl + '/UpdateUIData',
    setGroups: customDashboardBaseUrl + '/SetGroups',
    create: customDashboardBaseUrl,
    update: customDashboardBaseUrl,
    list: customDashboardBaseUrl,
    addWidget: customDashboardBaseUrl + '/AddWidget',
    updateWidget: customDashboardBaseUrl + '/UpdateWidget',
    removeWidget: (id: string) => customDashboardBaseUrl + `/Widget/${encodeURIComponent(id)}`,
}

const vinBaseUrl = apiUrl + 'CleanAF/Vin';
export const vinApis = {
    baseUrl: vinBaseUrl,
    decode: (vin) => vinBaseUrl + '/decode?vin=' + encodeURIComponent(vin),
}

const purchaseBaseUrl = apiUrl + 'CleanAF/Purchase';
export const purchaseApis = {
    baseUrl: purchaseBaseUrl,
    getETAForPart: (partNo: string, warehouseCode: string) => purchaseBaseUrl + `/GetETAForPart?partNumber=${encodeURIComponent(partNo)}&warehouseCode=${encodeURIComponent(warehouseCode)}`,
    updateETAInfo: purchaseBaseUrl + '/UpdateETAInfo',
    getPurchasingKeyForPlanning: purchaseBaseUrl + '/GetPurchasingKeyForPlanning',
}

const newSalesPersonApiBaseUrl = apiUrl + 'CleanAF/NewSalesPerson';
export const newSalesPersonApis = {
    baseUrl: newSalesPersonApiBaseUrl,
    listSalesPerson: (keyword: string) => newSalesPersonApiBaseUrl + `/ListSalesPerson?keyword=${encodeURIComponent(keyword?.trim())}`,
    grantWarehouseAccess: newSalesPersonApiBaseUrl + '/GrantWarehouseAccess',
    delete: (operatorId: string) => newSalesPersonApiBaseUrl + `/Delete?operatorId=${encodeURIComponent(operatorId)}`,
    updateConfig: newSalesPersonApiBaseUrl + '/UpdateConfig',
}


const territoryApiBaseUrl = apiUrl + 'CleanAF/Territory';
export const territoryApis = {
    baseUrl: territoryApiBaseUrl,
    list: territoryApiBaseUrl + '/List',
    create: territoryApiBaseUrl,
    update: territoryApiBaseUrl,
    delete: territoryApiBaseUrl,
}

const partWarehouseBaseUrl = apiUrl + 'CleanAF/PartWarehouse';
export const partWarehouseApis = {
    baseUrl: partWarehouseBaseUrl,
    reOrderReport: partWarehouseBaseUrl + '/ReOrderReport',
    updatePartWarehouse: partWarehouseBaseUrl,
    getForPart: (partId: number) => partWarehouseBaseUrl + `?partId=${encodeURIComponent(partId)}`,
}

// dimensions
const orderDimensionBaseUrl = apiUrl + 'CleanAF/OrderDimension';
export const orderDimensionApis = {
    baseUrl: orderDimensionBaseUrl,
    list: orderDimensionBaseUrl + '/List',
    create: orderDimensionBaseUrl,
    update: orderDimensionBaseUrl,
    delete: orderDimensionBaseUrl + "/RemoveItem",
}

const orderPalletBaseUrl = apiUrl + 'CleanAF/OrderPallet';
export const orderPalletApis = {
    baseUrl: orderPalletBaseUrl,
    list: orderPalletBaseUrl + '/List',
    create: orderPalletBaseUrl,
    update: orderPalletBaseUrl,
    delete: orderPalletBaseUrl,
}

const partSizeBaseUrl = apiUrl + 'CleanAF/PartSize';
export const partSizeApis = {
    baseUrl: partSizeBaseUrl,
    list: (partId: number) => partSizeBaseUrl + `?partId=${encodeURIComponent(partId)}`,
    create: partSizeBaseUrl,
    update: partSizeBaseUrl,
    delete: partSizeBaseUrl,
    setPartSizes: partSizeBaseUrl + '/SetPartSizes',
}

const vendorPartBaseUrl = apiUrl + 'CleanAF/VendorPart';
export const vendorPartApis = {
    baseUrl: vendorPartBaseUrl,
    list: vendorPartBaseUrl + '/List',
    getVendorsByPartNumber: vendorPartBaseUrl + '/GetVendorsByPartNumber',
    create: vendorPartBaseUrl,
    update: vendorPartBaseUrl,
    delete: (id: number) => vendorPartBaseUrl + `?id=${id}`,
}

const partFormBaseUrl = apiUrl + 'CleanAF/PartForm';
export const partFormApis = {
    baseUrl: partFormBaseUrl,
    list: (partId: number) => partFormBaseUrl + `/ListPartForm?partId=${encodeURIComponent(partId)}`,
    add: partFormBaseUrl + '/AddPartForm',
    update: partFormBaseUrl + '/UpdatePartForm',
    delete: (partFormId: number) => partFormBaseUrl + `/DeletePartForm?id=${encodeURIComponent(partFormId)}`,
}

const customisePageBaseUrl = apiUrl + 'CleanAF/CustomisePage';
export const dynamicPageApis = {
    baseUrl: customisePageBaseUrl,
    list: customisePageBaseUrl + '/List',
    create: customisePageBaseUrl,
    update: customisePageBaseUrl,
    remove: customisePageBaseUrl,
    get: (pageId: number | string) => customisePageBaseUrl + `?id=${encodeURIComponent(pageId)}`,
}

const priceFormulaBaseUrl = apiUrl + 'CleanAF/PriceFormula';
export const priceFormulaApis = {
    baseUrl: priceFormulaBaseUrl,
    listTemplates: priceFormulaBaseUrl + '/ListTemplates',
    getTemplate: (id: number) => priceFormulaBaseUrl + `/GetTemplate/${id}`,
    createTemplate: priceFormulaBaseUrl,
    updateTemplate: priceFormulaBaseUrl + '/UpdateTemplate',
    setTemplateItems: priceFormulaBaseUrl + '/SetTemplateItems',
    deleteTemplate: (id: number) => priceFormulaBaseUrl + `/${id}`,
    getProductFormulas: (id: number) => priceFormulaBaseUrl + `?partId=${id}`,
    setProductFormulas: priceFormulaBaseUrl,
}


/**
 * Inventory transfer apis
 */
const inventoryTransferBaseUrl = apiUrl + 'CleanAF/InventoryTransfer';
export const inventoryTransferApis = {
    baseUrl: inventoryTransferBaseUrl,
    createTransfer: inventoryTransferBaseUrl + '/CreateTransfer',
    listInventoryTransfers: inventoryTransferBaseUrl + '/ListInventoryTransfers',
    getInventoryTransfer: inventoryTransferBaseUrl + '/GetInventoryTransfer',
    addPartsToTransfer: inventoryTransferBaseUrl + '/AddPartsToTransfer',
    removePartsFromTransfer: inventoryTransferBaseUrl + '/RemovePartsFromTransfer',
    updateTransferItemBasicInfo: inventoryTransferBaseUrl + '/UpdateTransferItemBasicInfo',
    updateTransferItemCoreInfo: inventoryTransferBaseUrl + '/UpdateTransferItemCoreInfo',
    commitItem: inventoryTransferBaseUrl + '/CommitItem',
    uncommitItem: inventoryTransferBaseUrl + '/UncommitItem',
    updateTransferStatus: inventoryTransferBaseUrl + '/UpdateTransferStatus',
    postTransfer: inventoryTransferBaseUrl + '/PostTransfer',
}

/**
 * Contact Us / ContactMessage Apis (CleanAF)
 */
const contactMessageBaseUrl = apiUrl + 'CleanAF/ContactMessage';
export const contactMessageApis = {
    baseUrl: contactMessageBaseUrl,
    list: contactMessageBaseUrl + '/List',
    unreadCount: contactMessageBaseUrl + '/UnreadCount',
    setView: contactMessageBaseUrl + '/SetView',
    delete: (id: number | string) => contactMessageBaseUrl + `/${encodeURIComponent(id)}`,
}

/**
 * User Apis (CleanAF)
 */
const userV2BaseUrl = apiUrl + 'CleanAF/User';
export const userV2Apis = {
    baseUrl: userV2BaseUrl,
    resendActivation: userV2BaseUrl + '/ResendActivation',
}
